[
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Factor Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "عامل درِجَة السعادة"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Impact / Factor",
    "translations": [
      {
        "language": "AR",
        "text": "التأثير / العامل"
      },
      {
        "language": "EN",
        "text": "Impact / Factor"
      }
    ]
  },
  {
    "key": "ORG_T_10_TITLE",
    "text": "Customize View",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_TITLE",
    "text": "eNPS View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض صافي نقاط ترويج الموظفين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_DESCRIPTION",
    "text": "Switch to the eNPS tab to compare Employee Net Promoter Scores across your entities and see how they measure up against each other. ",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى تبويب صافي نقاط ترويج الموظفين لمقارنة نتائج الوحدات ومعرفة كيف تتقارن فيما بينها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_TITLE",
    "text": "Multi-Compare Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_20_DESCRIPTION",
    "text": "Download the multi-compare report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة المتعددة لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_2",
    "text": "Switch to the positional view to explore the org chart based on superiors and their teams, helping you understand happiness dynamics at the team level and identify where leadership is making an impact. ",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى العرض حسب الهيكل الوظيفي لعرض أداء كل مدير مباشر والفريق التابع له. يمكنك من خلاله فهم مستويات السعادة على مستوى الفرق، وتحديد مدى تأثير القيادة على النتائج."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION_P",
    "text": "See how your superior teams stack up against each other. Use Multi-Compare to compare happiness scores across multiple superiors at once, or Peer-to-Peer to put two superiors' side by side by checking the boxes, making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت درجات السعادة بين فرق المدراء المختلفة. استخدم المقارنة المتعددة لمقارنة درجات السعادة بين المدراء دفعة واحدة، أو المقارنة بين مديرين لوضع المدراء وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION_P",
    "text": "Compare scores across multiple superiors and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن النتائج بين المدراء والفرق التابعة لهم واطّلع على أدائهم مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION_P",
    "text": "Sort superior team scores in ascending or descending order to quickly identify your top and lowest engaged superiors. ",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج فرق المدراء تصاعديًا أو تنازليًا لتحديد المدراء الأعلى والأقل اندماجًا."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION_P",
    "text": "Go beyond the overall scores, select a specific happiness factor to see how your superior teams are scoring on each area of happiness.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج السعادة الكلية واختر عاملاً محددًا للسعادة لمعرفة درجات فرق المدراء في كل عامل من عوامل السعادة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_19_DESCRIPTION_P",
    "text": "Switch to the eNPS tab to compare scores across your superior teams and see how they measure against each other.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى تبويب صافي نقاط ترويج الموظفين لمقارنة نتائج فرق المدراء ومعرفة كيف تتقارن فيما بينها."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE",
    "text": "Change Superiors",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير المدراء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION",
    "text": "Use the dropdown to switch between superiors and explore different superior teams’ comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير المدراء واستعرض المقارنات بين الفرق التابعة لهم."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE",
    "text": "Peer-to-Peer Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين مديرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results. Note: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين مديرين لمراجعة نتائج المقارنة أو مشاركتها بسهولة. ملحوظة: متوفر في صيغة PDF."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_TITLE",
    "text": "Multi Compare",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION",
    "text": "Compare scores across multiple entities and see how they perform against the organization’s overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات الاندماج الوظيفي عبر عدة وحدات واطّلع على أدائها مقارنة بالنتائج الكلية للمؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_TITLE",
    "text": "Sorting",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION",
    "text": "Sort entity scores in ascending or descending order to quickly identify your top and lowest happy entities. ",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج الوحدات تصاعديًا أو تنازليًا لتحديد الوحدات الأعلى والأقل سعادة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_TITLE",
    "text": "Factor Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار العوامل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION",
    "text": "Go beyond the overall scores, select a specific happiness factor to see how your entities are scoring on each area of happiness.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج السعادة الكلية واختر عاملاً محددًا للسعادة لمعرفة درجات الوحدات في كل عامل من عوامل سعادة الموظف."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_DESCRIPTION",
    "text": "Click here to re-center the org chart and bring it back to the default view.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أيقونة التمركز لإعادة الهيكل التنظيمي فورًا إلى منتصف الشاشة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_2",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_1",
    "text": "Functional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_1",
    "text": "View your org chart by function to see how your entities are structured and how happiness scores are distributed across them, giving you a clear picture of performance at every level of your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض الهيكل التنظيمي حسب الإدارات لترى كيف يتم تنظيم الوحدات داخل مؤسستك وكيف تتوزع درجات السعادة بينها، مما يمنحك صورة واضحة عن الأداء على مختلف مستويات المؤسسة."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_10_DESCRIPTION",
    "text": "Customize your view by changing the layout, displaying key analysis, or selecting a specific factor to explore deeper insights. Note: A maximum of 3 options can be selected",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير طريقة عرض النتائج من خلال تعديل التخطيط، أو إظهار أبرز التحليلات، أو اختيار عامل محدد للتعمّق في التحليلات. ملاحظة: يمكن اختيار 3 خيارات كحد أقصى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_TITLE",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION",
    "text": "See how your entities stack up against each other. Use Multi-Compare to compare happiness scores across multiple entities at once, or Peer- to-Peer to put two entities side by side by checking the boxes — making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت الوحدات فيما بينها. استخدم المقارنة المتعددة لمقارنة درجات السعادة بين عدة وحدات دفعة واحدة، أو المقارنة بين وحدتين لوضع وحدتين وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين مديرين"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION",
    "text": "Easily spot differences in happiness scores and key factors between entities — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات السعادة والعوامل الرئيسية بين الوحدات بسهولة — معروضة جنبًا إلى جنب."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_DESCRIPTION",
    "text": "Zoom in to take a closer look at specific areas of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتكبير العرض لإلقاء نظرة أقرب على مناطق محددة في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_TITLE",
    "text": "Zoom Out",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_4_DESCRIPTION",
    "text": "Zoom out to see the bigger picture of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتصغير العرض لرؤية الصورة الأشمل لهيكل مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_TITLE",
    "text": "Collapse",
    "translations": [
      {
        "language": "AR",
        "text": "طيّ"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_5_DESCRIPTION",
    "text": "Collapse the entire org chart at once to reset the view and start fresh from the top level.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بطي الهيكل التنظيمي بالكامل لإعادة ضبط العرض والبدء من المستوى الأعلى."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_TITLE",
    "text": "Expand",
    "translations": [
      {
        "language": "AR",
        "text": "توسيع"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_6_DESCRIPTION",
    "text": "Want to see the full picture? Expand the org chart to reveal all levels and details across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد رؤية الصورة الكاملة؟ قم بتوسيع الهيكل التنظيمي لاستعراض جميع المستويات والتفاصيل في مؤسستك."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_TITLE",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "ملء الشاشة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_7_DESCRIPTION",
    "text": "Switch to full-screen mode for a wider, more immersive view of your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى وضع ملء الشاشة للحصول على عرض أوسع وأشمل للهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_8_TITLE",
    "text": "Center",
    "translations": [
      {
        "language": "AR",
        "text": "التمركز"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_3_TITLE",
    "text": "Zoom In",
    "translations": [
      {
        "language": "AR",
        "text": "تكبير العرض"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_2_DESCRIPTION",
    "text": "Quickly find what you need using the search bar — search by entity or superior and navigate directly to the right spot in your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم شريط البحث للوصول السريع إلى ما تحتاجه — ابحث حسب الوحدة أو المسؤول المباشر وانتقل فورًا إلى موقعه في الهيكل التنظيمي."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_1_DESCRIPTION",
    "text": "In the \"Org chart\" page, you can explore your organization's structure — whether by function or position — and see how each level is performing at a glance, making it easier to spot strengths and areas for growth.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"الهيكل التنظيمي\"، يمكنك استعراض هيكل مؤسستك — سواء التنظيمي أو الوظيفي — والاطّلاع على أداء كل مستوى بنظرة واحدة، مما يسهّل عليك تحديد نقاط القوة وفرص التطوير."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "ORG_T_1_TITLE",
    "text": "Org chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AllFactor_259",
    "text": "All Factors",
    "translations": [
      {
        "language": "AR",
        "text": "جميع العوامل"
      }
    ]
  },
  {
    "key": "txt_Discoverh_474",
    "text": "Discover how your happiness scores stack up against the competition – are you leading the way? Click here and find out how your scores are compared to MENA Benchmark and Top Performers!",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفوق نتائج الاندماج الوظيفي الخاصة بك بالمقارنة مع الشركات المنافسة – هل تُعد شركتكم الرائدة في الاندماج الوظيفي؟ انقر هنا واكتشف كيف يتم مقارنة نتائجك مع معايير الشرق الأوسط والأداء الأفضل!"
      }
    ]
  },
  {
    "key": "EXTREMELYHAPPY",
    "text": "Extremely Happy",
    "translations": [
      {
        "language": "AR",
        "text": "سعيد للغاية"
      }
    ]
  },
  {
    "key": "EXTREMELYUNHAPPY",
    "text": "Extremely Unhappy",
    "translations": [
      {
        "language": "AR",
        "text": "غير سعيد إطلاقاً"
      }
    ]
  },
  {
    "key": "txt_Pleasesel_557",
    "text": "Please select the respondent(s)",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Notavaila_825",
    "text": "Not available while extra factor is turned on.",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Factor",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة السعادة"
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل"
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Happiness Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لاستبيان سعادة الموظف:"
      }
    ]
  },
  {
    "key": "txt_FactorSco_126",
    "text": "Factor Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العامل"
      }
    ]
  },
  {
    "key": "txt_Happiness_795",
    "text": "Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة السعادة"
      }
    ]
  },
  {
    "key": "txtHappinessComparison",
    "text": "Happiness Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة السعادة"
      }
    ]
  },
  {
    "key": "txt_OverallEm_172",
    "text": "Overall Employee Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية لسعادة الموظف"
      }
    ]
  },
  {
    "key": "txt_Factor:s_700",
    "text": "Factor: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Workplace_690",
    "text": "Workplace Happiness Scores",
    "translations": [
      {
        "language": "AR",
        "text": "السعادة في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_Planning&_544",
    "text": "Planning & Action",
    "translations": [
      {
        "language": "AR",
        "text": "التخطيط والعمل"
      }
    ]
  },
  {
    "key": "txt_Analysis&_642",
    "text": "Analysis & insights",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات"
      }
    ]
  },
  {
    "key": "txt_ActionPla_480",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "txt_DateClose_105",
    "text": "Date Closed",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإغلاق"
      }
    ]
  },
  {
    "key": "txt_Overallha_759",
    "text": "Overall Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة السعادة الكلية"
      }
    ]
  },
  {
    "key": "txt_closed_670",
    "text": "Closed",
    "translations": [
      {
        "language": "AR",
        "text": "مغلق"
      }
    ]
  },
  {
    "key": "txt_BacktoSur_720",
    "text": "Back to Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع إلى الاستبيانات"
      }
    ]
  },
  {
    "key": "ORG_POS_MeanScore",
    "text": "Team Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة سعادة الفريق"
      }
    ]
  },
  {
    "key": "CompanyMeanScore",
    "text": "Company Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الشركة"
      }
    ]
  },
  {
    "key": "txt_Orchart_440",
    "text": "Org Chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "txt_response_rate_status",
    "text": "RESPONDENTS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": " المستجيبون حسب الحالة"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txt_Workplace_703",
    "text": "Workplace Happiness By",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txtSareHT",
    "text": "Share Survey",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Useouradv_513",
    "text": "Use our advanced AI tool to generate statements tailored to your need! ",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك! "
      }
    ]
  },
  {
    "key": "txt_GenerateS_831",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      }
    ]
  },
  {
    "key": "txt_Youcanexp_908",
    "text": "You can export the comparison charts as per the current view. </br> Note: Available in PDF format",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل الرسوم البيانية للمقارنة وفقًا للعرض الحالي.</br> ملحوظة: متوفر في صيغة PDF. "
      }
    ]
  },
  {
    "key": "txt_Selectthe_788",
    "text": "Select the companies (if any) you want to compare. </br>Hint: if you have multiple surveys, you have the option to view average scores or select surveys for a tailored analysis! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الشركات (إن وُجد) التي ترغب في مقارنتها. </br>تلميح: إذا كانت لديك استبيانات متعددة، يُتاح لك خيار عرض متوسط الدرجات أو تحديد الاستبيانات التي ترغب في مقارنتها للحصول على تحليل مخصص. "
      }
    ]
  },
  {
    "key": "txt_Selectthe_681",
    "text": "Select the start and end dates to view the analysis for a specific timeframe. ",
    "translations": [
      {
        "language": "AR",
        "text": "لعرض نتائج سعادة الموظف لفترة زمنية معينة، قم باختيار تواريخ البداية والنهاية. "
      }
    ]
  },
  {
    "key": "txt_Clickonb_566",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type.</br> Hint: Click “👁️” to preview the statement sample used in the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق.</br> تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالنقر هنا."
      }
    ]
  },
  {
    "key": "txt_Unlockthe_743",
    "text": "Unlock the power of your preferences! Revisit the criteria you chose in the survey setup and experience an analysis tailored to your specifications! <br><br>Hint: The system is interactive. Click on the chart legend to turn on/off options and have a clearer view of the results.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-happiness.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف قوة تحليلات زينيثرمع اختياراتك في إعدادات الاستبيان! استمتع بتجربة مصممة ومفصّلة وفق مواصفاتك! <br><br>تلميح: النظام تفاعلي. انقر على مفتاح الرسم البياني لتفعيل/إيقاف الخيارات والحصول على رؤية أوضح للنتائج.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-happiness.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Export_828",
    "text": "Export ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Elevateyo_771",
    "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "ارفع مستوى التحليلات بنقرة واحدة - قم بتحميل مخطط تمثيل البيانات بالألوان الخاصة بك!<br><br>ملحوظة: متوفرة في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_Clickonea_759",
    "text": "Click on each factor to expand the results of their statements.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على كل عامل سعادة لعرض نتائج العبارات الخاصة بهم."
      }
    ]
  },
  {
    "key": "txt_ExpandDri_767",
    "text": "Expand Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عرض العوامل"
      }
    ]
  },
  {
    "key": "txt_Discovert_637",
    "text": "Discover the survey's highlights and insights in a summarized analysis! Compare the %difference between the overall score and factors & statements to demographics and custom criteria by selecting from the breakout dropdown",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف أبرز نقاط التحليلات المُفصّلة في تحليل مُلخص! قارن الفرق في النسب بين درجة السعادة الكلية وعوامل سعادة الموظف والعبارات بالنسبة إلى الجوانب الديموغرافية والمعايير المخصصة وذلك من خلال من خلال الاختيار من القائمة المنسدلة."
      }
    ]
  },
  {
    "key": "txt_Clickhere_159",
    "text": "Click here to download all comments.</br>Note: Available in Excel format ",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات. </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txt_Expandthe_771",
    "text": "Expand the factor to view each statement score and the distribution of respondents’ answers. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عامل السعادة لعرض متوسط كل عبارة وتوزيع إجابات المستجيبين. "
      }
    ]
  },
  {
    "key": "txt_Statement_356",
    "text": "Statements Score ",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات "
      }
    ]
  },
  {
    "key": "txt_Changethe_922",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالنقر هنا. "
      }
    ]
  },
  {
    "key": "txt_ChartType_839",
    "text": "Chart Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني "
      }
    ]
  },
  {
    "key": "txtRespondentComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      }
    ]
  },
  {
    "key": "txtQuestionsAnalysisbyDriver_desc",
    "text": "In \"Statements\", each factor’s score with its corresponding statement is shown. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل عامل مع العبارات الخاصة به."
      }
    ]
  },
  {
    "key": "txtResponses_desc",
    "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the survey setup step. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليل المستجيبون\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المخُتارة في خطوة إعداد الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Discoverh_659",
    "text": "Discover how your happiness scores stack up against the competition – are you leading the way? Click here and find out how your scores are compared to MENA Benchmark and Top Performers! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفوق نتائج سعادة الموظفين الخاصة بك بالمقارنة مع الشركات المنافسة – هل تُعد شركتكم الرائدة في سعاد الموظف؟ انقر هنا واكتشف كيف يتم مقارنة نتائجك مع معايير الشرق الأوسط والأداء الأفضل! "
      }
    ]
  },
  {
    "key": "txt_Clickhere_702",
    "text": "Click here to download the report and turn on the sections you want to include. </br>Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.",
    "translations": [
      {
        "language": "AR",
        "text": " انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير. </br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\"</b> وابدأ بالتحميل الآن! - متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "txt_Clickhere_662",
    "text": "Click here to filter the analysis by choosing the entity.</br> Note: The number of respondents must be at least 3 to view the analysis of each entity. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. </br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل وحدة تنظيمية مختارة. "
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page shows the employee happiness scores, detailed comparison, and other valuable insights.  ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>“نظرة عامة”</b> تعرض نتائج سعادة الموظفين وتحليل القراءات والبيانات بشكل مفصّل ومعمّق."
      }
    ]
  },
  {
    "key": "txt_CloseSurv_416",
    "text": "Close Survey",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الاستبيان "
      }
    ]
  },
  {
    "key": "txt_ClickOn_528",
    "text": "Click on <b>“Close Now”</b> to close the survey.  </br>Note: You cannot add or delete respondents once you close the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>“أغلق الآن”</b> لإغلاق الاستبيان. </br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txt_Unlocksea_518",
    "text": "Unlock seamless employee engagement – Reach respondents, even without email, with our general survey link. Click here and start sharing! ",
    "translations": [
      {
        "language": "AR",
        "text": "   جميع المستجيبون يستطيعون المشاركة – يمكنك الوصول إلى المستجيبين حتى بدون بريد إلكتروني باستخدام رابط الاستبيان. انقر هنا وابدأ بالمشاركة! "
      }
    ]
  },
  {
    "key": "txt_UpdateDat_941",
    "text": "Update Dates ",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ "
      }
    ]
  },
  {
    "key": "txt_Diditgobe_889",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكيرالتلقائي. "
      }
    ]
  },
  {
    "key": "txt_Youcandow_532",
    "text": "You can download the list of respondents with their survey status! </br> Note: Available in Excel format. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة الاستبيان الخاص بهم! </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txt_ExportRes_128",
    "text": "Export Respondents ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون "
      }
    ]
  },
  {
    "key": "txt_Forgottoa_219",
    "text": "Forgot to add a respondent? No worries, click here and start adding. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة. "
      }
    ]
  },
  {
    "key": "txt_Sendmanua_129",
    "text": "Send manual reminders or delete the respondent. ",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب. "
      }
    ]
  },
  {
    "key": "txt_MoreActio_120",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_Clickhere_145",
    "text": "Click here to send reminders to respondents who did not complete the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للمستجيبين الذين لم يستكملوا الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Trackyour_168",
    "text": "Track your respondents' progress! </br> Note: We recommend a 65% - 75% response rate for a better analysis. ",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين. </br>ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل. "
      }
    ]
  },
  {
    "key": "txt_Invitatio_215",
    "text": "Invitation Template ",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة "
      }
    ]
  },
  {
    "key": "txt_Onceyouse_314",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the survey invitations and go live!  ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>“دعوة لاستكمال الاستبيان”</b>، انقر هنا لإرسال دعوات الاستبيان وإطلاق الاستبيان مباشرةً!"
      }
    ]
  },
  {
    "key": "txt_Customize_781",
    "text": "Customize the invitation email template or use the default template generated by Zenithr. </br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة  أو استخدم النموذج الأساسي المُعرف من زينثر.</br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"<b>النموذج الأساسي</b>\"."
      }
    ]
  },
  {
    "key": "txt_step_4",
    "text": "One more step, and you’re ready to go! ",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد الاستبيان! "
      }
    ]
  },
  {
    "key": "txt_step_3",
    "text": "You are ready to go to the next step! ",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_Customize_297",
    "text": "Customize the reminder email template or use the default template generated by Zenithr.</br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل التذكير أو استخدم النموذج الأساسي المُعرف من زينثر.</br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"<b>النموذج الأساسي</b>\"."
      }
    ]
  },
  {
    "key": "txt_ReminderT_911",
    "text": "Reminder Template ",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير "
      }
    ]
  },
  {
    "key": "txt_Addupto3a_148",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Automated_437",
    "text": "Automated Reminders ",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية "
      }
    ]
  },
  {
    "key": "txt_SurveyDea_220",
    "text": "Survey Deadline ",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال الاستبيان "
      }
    ]
  },
  {
    "key": "txt_Setthecom_342",
    "text": "Set the completion date of your survey!<br><br> Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال الاستبيان! <br><br>تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      }
    ]
  },
  {
    "key": "txt_invitation_email_desc",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>“دعوة لاستكمال الاستبيان”</b> تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المستجيبون\"</b> من خلال البريد الإلكتروني."
      }
    ]
  },
  {
    "key": "txt_timeframe_desc",
    "text": "In <b>“Timeframe”</b>, you set the survey deadline in addition to automated reminders. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>“المدة الزمنية”</b>، يمكنك تحديد الإطار الزمني للاستبيان بالإضافة إلى تذكيرات تلقائية لاستكمال الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Tostartad_220",
    "text": "To start adding respondents, click on <b>“Add Respondent”</b>.</br> Hint: We recommend adding by using Excel to save time and simplify your experience! ",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>“إضافة مستجيب”</b>. <br/> تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      }
    ]
  },
  {
    "key": "txt_respondents_desc",
    "text": "In the <b>“Respondents”</b> page, you add the Respondents you want to invite to the survey manually, or by Excel file, or from your respondent pool. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المستجيبون\"</b>، يمكنك إضافة المستجيبين الذين ترغب في دعوتهم للاستبيان يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      }
    ]
  },
  {
    "key": "txt_step_2",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the survey.<br><img class=\"mt-2\" src=\"assets/img/tours/happiness-res-info.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء الاستبيان.<br/><img class=\"mt-2\" src=\"assets/img/tours/happiness-res-info.gif\" />"
      }
    ]
  },
  {
    "key": "txt_CustomCri_149",
    "text": "Custom Criteria ",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      }
    ]
  },
  {
    "key": "txt_Youcancre_632",
    "text": "You can create additional criteria. </br>Fill in the criterion name and its options. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية. </br>قم بتعبئة اسم المعيار وخياراته."
      }
    ]
  },
  {
    "key": "txt_analytical_criteria_desc",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!<img class=\"mt-2\" src=\"assets/img/tours/analytical-criteria.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br><br>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!<img class=\"mt-2\" src=\"assets/img/tours/analytical-criteria.gif\" />"
      }
    ]
  },
  {
    "key": "txt_step_1",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_Nextstep_435",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_Clickonb_749",
    "text": "Click on <b>“Preview Survey”</b> to view your Survey's selected factors and statements! </br>  Note: Available in PDF format. To download click “📁”. ",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على <b>“عرض الاستبيان”</b> لعرض العوامل والعبارات المختارة في الاستبيان الخاص بك!! </br> ملاحظة: متوفر بصيغة PDF. لتنزيل الملف اضغط على “📁”."
      }
    ]
  },
  {
    "key": "txt_Editordel_384",
    "text": "Edit or delete the new custom Factor. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف العامل المخصص الجديد. "
      }
    ]
  },
  {
    "key": "txt_EditCusto_550",
    "text": "Edit Custom Factor",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل العامل المخصص "
      }
    ]
  },
  {
    "key": "txt_Ifyouwant_710",
    "text": "If you want to add more statements, first click <b>“New Custom Factor”</b>.</br></br> Note: Total Factors covering <b>6Cs</b> and Custom Factors shall not exceed 8 Factors. ",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على <b>\"عامل مخصص جديد\"</b>.<br><br> ملحوظة: يجب ألا يتجاوز إجمالي العوامل التي تغطي <b>6Cs</b> والعوامل المخصصة 8 عوامل."
      }
    ]
  },
  {
    "key": "txt_Maximizey_590",
    "text": "Maximize your experience with the full <b>6Cs</b>, or tailor it to your needs by selecting a minimum of 4 factors. ",
    "translations": [
      {
        "language": "AR",
        "text": "حقق أقصى استفادة من تجربة سعادة الموظف مع نموذج <b>6Cs</b> الكامل، أو قم بتخصيصه ليناسب احتياجاتك عن طريق اختيار 4 عوامل على الأقل."
      }
    ]
  },
  {
    "key": "txt_Translati_697",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "txt_translation_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      }
    ]
  },
  {
    "key": "txt_Fillinyou_655",
    "text": "Fill in your <b>\"Survey Name\"</b>. </br></br> You can add a description as well. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة <b>اسم الاستبيان</b>.</br></br> يمكنك أيضاً إضافة وصف للاستبيان."
      }
    ]
  },
  {
    "key": "txt_SurveyDet_371",
    "text": "Survey Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الاستبيان "
      }
    ]
  },
  {
    "key": "txt_survey_info_desc",
    "text": "In <b>“Survey Information</b>”, you specify the main elements, including survey name and factors & statements! ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"معلومات الاستبيان\"</b> تُحدد العناصر الرئيسية، بما في ذلك اسم الاستبيان والعوامل والعبارات."
      }
    ]
  },
  {
    "key": "txt_Clickhere_208",
    "text": "Click here to delete a draft survey.<br><br> Note: only draft surveys can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف الاستبيانات المسودة. <br><br>ملحوظة: يمكن حذف استبيانات المسودة فقط"
      }
    ]
  },
  {
    "key": "txt_DeleteSur_232",
    "text": "Delete Survey",
    "translations": [
      {
        "language": "AR",
        "text": "حذف استبيان "
      }
    ]
  },
  {
    "key": "txt_Pointthem_434",
    "text": "Point the mouse over the survey list to open draft, live, and closed surveys. ",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة الاستبيانات لفتح الاستبيانات بحالة المسودة، المباشرة، والمنتهية."
      }
    ]
  },
  {
    "key": "txt_OpenSurve_592",
    "text": "Open Survey ",
    "translations": [
      {
        "language": "AR",
        "text": "فتح استبيان "
      }
    ]
  },
  {
    "key": "txt_Tocreatea_600",
    "text": "To create a new survey, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقرعلى <b>\"إعداد جديد\"</b> لإنشاء استبيان جديد."
      }
    ]
  },
  {
    "key": "txtBy",
    "text": "by",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      }
    ]
  },
  {
    "key": "txtChooseLanguage",
    "text": "Choose Langauge",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار اللغة"
      }
    ]
  },
  {
    "key": "Applied Filters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر المُطبَّقة"
      }
    ]
  },
  {
    "key": "Performance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      }
    ]
  },
  {
    "key": "Tenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics\t",
    "translations": [
      {
        "language": "AR",
        "text": "التركيبة السكانية"
      }
    ]
  },
  {
    "key": "Extra Criteria",
    "text": "Extra Criteria\t",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      }
    ]
  },
  {
    "key": "Business Level",
    "text": "Business Level\t",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grades",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الوظيفية"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Levels",
    "translations": [
      {
        "language": "AR",
        "text": "المستويات الوظيفية"
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rates",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات الأداء"
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Groups\t",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Groups",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "التوصييات"
      }
    ]
  },
  {
    "key": "downloadComments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليقات"
      }
    ]
  },
  {
    "key": "preparingComments",
    "text": "Preparing Comments",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التعليقات"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Preview Sample",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txt_Sample_Question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      }
    ]
  },
  {
    "key": "TXTDRIVER/QUESTION",
    "text": "FACTOR/ STATEMENT",
    "translations": [
      {
        "language": "AR",
        "text": "عامل / عبارة"
      }
    ]
  },
  {
    "key": "txtDifference",
    "text": "Difference",
    "translations": [
      {
        "language": "AR",
        "text": "الفرق"
      }
    ]
  },
  {
    "key": "txt_Responden_728",
    "text": "Respondents Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات حالة المستجيبون"
      }
    ]
  },
  {
    "key": "txtHappinessIndexScaleBy",
    "text": "Employee Happiness Index by ",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر سعادة الموظف حسب "
      }
    ]
  },
  {
    "key": "txt_ResultsIn_891",
    "text": "Results Indication",
    "translations": [
      {
        "language": "AR",
        "text": "دلالة النتائج"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_565",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      }
    ]
  },
  {
    "key": "txt_BACKTOSUR_422",
    "text": "BACK TO SURVEYS",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع إلى قائمة الاستبيانات"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      }
    ]
  },
  {
    "key": "txt_Share_survey",
    "text": "Share Survey",
    "translations": [
      {
        "language": "AR",
        "text": "شارك الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Share",
    "text": "Share",
    "translations": [
      {
        "language": "AR",
        "text": "شارك"
      }
    ]
  },
  {
    "key": "txt_NewStatem_408",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_862",
    "text": "Add up to 5 statements",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 5 عبارات"
      }
    ]
  },
  {
    "key": "txt_NewCustom_150",
    "text": "New Custom Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل مخصص جديد"
      }
    ]
  },
  {
    "key": "txt_Selectupt_657",
    "text": "Select up to 8 Factors",
    "translations": [
      {
        "language": "AR",
        "text": "حدد ما يصل إلى 8 عوامل"
      }
    ]
  },
  {
    "key": "txt_Factornee_401",
    "text": "Factor needs have at least one statement",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل للعامل"
      }
    ]
  },
  {
    "key": "txt_Allfactor_914",
    "text": "All factors can't be more than 8!",
    "translations": [
      {
        "language": "AR",
        "text": "!يجب ألا يتخطى المجموع الكلي عن 8 عوامل"
      }
    ]
  },
  {
    "key": "txt_NewQuesti_933",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_C-Factors_788",
    "text": "6Cs Factors can't be less than 4!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن أن تكون عوامل 6Cs  أقل من 4!"
      }
    ]
  },
  {
    "key": "txt_Atleast3r_552",
    "text": "At least 3 respondents should complete the survey in order to close it",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txt_Descripti_202",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "txt_Optional_264",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      }
    ]
  },
  {
    "key": "txt_CustomFac_793",
    "text": "Custom Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل مخصصة"
      }
    ]
  },
  {
    "key": "txt_6CFactors_700",
    "text": "6Cs Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل 6Cs"
      }
    ]
  },
  {
    "key": "txt_STATEMENT_772",
    "text": "Statements of",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات"
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccess",
    "text": "Permission Required To Access This Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول إلى صفحة سعادة الموظف"
      }
    ]
  },
  {
    "key": "txtNoPermissonToAccessEntity",
    "text": "Permission Required To Access This Entity",
    "translations": [
      {
        "language": "AR",
        "text": "مطلوب ترخيص للسماح في الدخول الى الوحدة"
      }
    ]
  },
  {
    "key": "factor score across companies",
    "text": "factor score across companies",
    "translations": [
      {
        "language": "AR",
        "text": "للشركات المختارة على مدى السنوات"
      }
    ]
  },
  {
    "key": "The below chart represents the",
    "text": "The below chart represents the",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض الرسم البياني أدناه درجة سعادة الموظف لعامل "
      }
    ]
  },
  {
    "key": "The Workplace Happiness Score measures the overall happiness & perception across the organization. It is the average score of the selected factors.",
    "text": "The Workplace Happiness Score measures the overall happiness & perception across the organization. It is the average score of the selected factors.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة السعادة الوظيفية في مكان العمل عن الرضى والسعادة الكلية في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل السعادة."
      }
    ]
  },
  {
    "key": "The below chart represents the overall workplace happiness score for the selected companies across the years",
    "text": "The below chart represents the overall workplace happiness score for the selected companies across the years",
    "translations": [
      {
        "language": "AR",
        "text": "ويعرض الرسم البياني أدناه نتائج السعادة الوظيفية الكلية في مكان العمل حسب الشركات المختارة على مدى السنوات"
      }
    ]
  },
  {
    "key": "The below rating scale determines the happiness levels and what each level represents",
    "text": "The below rating scale determines the happiness levels and what each level represents",
    "translations": [
      {
        "language": "AR",
        "text": "يحدد مقياس التقييم أدناه مستويات سعادة الموظف وما يمثله كل مستوى."
      }
    ]
  },
  {
    "key": "Employee Happiness Levels",
    "text": "Employee Happiness Levels",
    "translations": [
      {
        "language": "AR",
        "text": "مستويات سعادة الموظف"
      }
    ]
  },
  {
    "key": "This report is a representation of the workplace happiness of the selected companies. The overall happiness score will help understand how the companies perform.",
    "text": "This report is a representation of the workplace happiness of the selected companies. The overall happiness score will help understand how the companies perform.",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح هذا التقرير مستوى سعادة الموظف للشركات المختارة وسوف تساعد النتيجة الإجمالية للسعادة في فهم كيفية أداء الشركات."
      }
    ]
  },
  {
    "key": "The factors and their happiness scores displayed in this report are a result of the employees' responses.",
    "text": "The factors and their happiness scores displayed in this report are a result of the employees' responses.",
    "translations": [
      {
        "language": "AR",
        "text": "إن عوامل السعادة المبينة في هذا التقرير ومستوى السعادة الخاص بها هي نتيجة وخلاصة استجابة الموظفين للاستبيانات."
      }
    ]
  },
  {
    "key": "Compare the overall workplace happiness score of the selected companies.",
    "text": "Compare the overall workplace happiness score of the selected companies.",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة درجة السعادة الوظيفية الإجمالية في مكان العمل للشركات المختارة."
      }
    ]
  },
  {
    "key": "Compare the results of the happiness factors of the selected companies.",
    "text": "Compare the results of the happiness factors of the selected companies.",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة نتائج السعادة الوظيفية لعوامل السعادة للشركات المختارة."
      }
    ]
  },
  {
    "key": "Obtain an overview of companies' performance towards the happiness factors to highlight areas of improvement of the low scores’ factors.",
    "text": "Obtain an overview of companies' performance towards the happiness factors to highlight areas of improvement of the low scores’ factors.",
    "translations": [
      {
        "language": "AR",
        "text": "الحصول على نظرة عامة على أداء الشركات لكل عوامل السعادة وتسليط الضوء على مجالات تحسين عوامل السعادة ذات النتائج المتدنية."
      }
    ]
  },
  {
    "key": "Comparative Analysis Report",
    "text": "Comparative Analysis Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة سعادة الموظف"
      }
    ]
  },
  {
    "key": "Employee Happiness is the extent to which an employee is happy or satisfied with their work and the workplace that they are in. In other words, are they happy with their job? Are they happy with the work environment and atmosphere?",
    "text": "Employee Happiness is the extent to which an employee is happy or satisfied with their work and the workplace that they are in. In other words, are they happy with their job? Are they happy with the work environment and atmosphere?",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظف هي مدى سعادة الموظف أو رضاه عن عمله ومكان العمل الذي يتواجد فيه. بمعنى آخر، هل هم سعداء بوظيفتهم؟ هل هم سعداء ببيئة العمل والجو العام؟"
      }
    ]
  },
  {
    "key": "Happiness is considered a powerful motivator that encourages employees to perform harder and invest more effort in achieving business goals in addition to its essential role in improving retention and promoting a driven workplace culture.",
    "text": "Happiness is considered a powerful motivator that encourages employees to perform harder and invest more effort in achieving business goals in addition to its essential role in improving retention and promoting a driven workplace culture.",
    "translations": [
      {
        "language": "AR",
        "text": "تعتبر السعادة حافزاً قوياً يشجع الموظفين على العمل بجدية أكبر واستثمار المزيد من الجهد في تحقيق أهداف العمل، بالإضافة إلى دورها الأساسي في تحسين معدل الاحتفاظ بالموظفين وتعزيز ثقافة مكان العمل."
      }
    ]
  },
  {
    "key": "This Employee Happiness Survey applies the 6Cs Model to measure employees’ happiness and satisfaction at the workplace, displayed in this report through indepth analysis, and scores.",
    "text": "This Employee Happiness Survey applies the 6Cs Model to measure employees’ happiness and satisfaction at the workplace, displayed in this report through indepth analysis, and scores.",
    "translations": [
      {
        "language": "AR",
        "text": "يُطبق استبيان سعادة الموظف \"نموذج 6Cs \" لقياس مدى سعادة الموظفين ورضاهم في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق والنتائج المفصّلة."
      }
    ]
  },
  {
    "key": "Comparative Analysis Report",
    "text": "Comparative Analysis Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة سعادة الموظف"
      }
    ]
  },
  {
    "key": "txt_new_setup",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      }
    ]
  },
  {
    "key": "Objective of this Report",
    "text": "Objective of this Report",
    "translations": [
      {
        "language": "AR",
        "text": "أهداف التقرير"
      }
    ]
  },
  {
    "key": "txt_survey_list",
    "text": "Survey List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الاستبيانات"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      }
    ]
  },
  {
    "key": "txtComparison",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة"
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "MENA",
    "translations": [
      {
        "language": "AR",
        "text": "الشرق الأوسط"
      }
    ]
  },
  {
    "key": "txtPrevious",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      }
    ]
  },
  {
    "key": "txtExtraFactor",
    "text": "Extra Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل السعادة الإضافي"
      }
    ]
  },
  {
    "key": "txtSurvey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      }
    ]
  },
  {
    "key": "txtCustomfactor",
    "text": "Add Custom Factor?",
    "translations": [
      {
        "language": "AR",
        "text": " أضف عامل سعادة مخصص"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعّال"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtbyfactors",
    "text": "By Factors",
    "translations": [
      {
        "language": "AR",
        "text": "حسب عوامل السعادة"
      }
    ]
  },
  {
    "key": "txtByCriteria",
    "text": "By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حسب المعايير"
      }
    ]
  },
  {
    "key": "txt_workplace_happiness",
    "text": "Workplace Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "السعادة في مكان العمل"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل السعادة"
      }
    ]
  },
  {
    "key": "txt_drivers_score",
    "text": "Factors' Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتائج عوامل السعادة"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txtComments2",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات"
      }
    ]
  },
  {
    "key": "txtComment",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      }
    ]
  },
  {
    "key": "txtHappinessScale",
    "text": "Employee Happiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر سعادة الموظفين"
      }
    ]
  },
  {
    "key": "txtQuestionsAnalysisbyDriver",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtSurveyRespondentList",
    "text": "Survey Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون للاستبيان"
      }
    ]
  },
  {
    "key": "txtYear",
    "text": "Year",
    "translations": [
      {
        "language": "AR",
        "text": "السنة"
      }
    ]
  },
  {
    "key": "txt_not_started",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يبدأ"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإتمام"
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      }
    ]
  },
  {
    "key": "txtRespondentComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      }
    ]
  },
  {
    "key": "txt_respondentsCount",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيب"
      }
    ]
  },
  {
    "key": "txtExtremelyUnhappy",
    "text": "Extremely Unhappy",
    "translations": [
      {
        "language": "AR",
        "text": "غير سعيد إطلاقاً"
      }
    ]
  },
  {
    "key": "txtUnhappy",
    "text": "Unhappy",
    "translations": [
      {
        "language": "AR",
        "text": "غير سعيد"
      }
    ]
  },
  {
    "key": "txtHappy",
    "text": "Happy",
    "translations": [
      {
        "language": "AR",
        "text": "سعيد"
      }
    ]
  },
  {
    "key": "txtExtremelyHappy",
    "text": "Extremely Happy",
    "translations": [
      {
        "language": "AR",
        "text": "سعيد للغاية"
      }
    ]
  },
  {
    "key": "EXTREME_UNHAPPY",
    "text": "Extremely Unhappy",
    "translations": [
      {
        "language": "AR",
        "text": "غير سعيد إطلاقاً"
      }
    ]
  },
  {
    "key": "UNHAPPY",
    "text": "Unhappy",
    "translations": [
      {
        "language": "AR",
        "text": "غير سعيد"
      }
    ]
  },
  {
    "key": "HAPPY",
    "text": "Happy",
    "translations": [
      {
        "language": "AR",
        "text": "سعيد"
      }
    ]
  },
  {
    "key": "EXTREME_HAPPY",
    "text": "Extremely Happy",
    "translations": [
      {
        "language": "AR",
        "text": "سعيد للغاية"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المختارة"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txtSurveys",
    "text": "Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "استبيانات"
      }
    ]
  },
  {
    "key": "Insufficient Credit, Please Contact Your Admin",
    "text": "Insufficient Credit, Please Contact Your Admin",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد غير كافي، يرجى الاتصال بالمسؤول"
      }
    ]
  },
  {
    "key": "txt_go_closed",
    "text": "This survey will now be closed and you will no longer be able to make any changes or add new respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا الاستبيان الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txtCommunication",
    "text": "Communication",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة"
      }
    ]
  },
  {
    "key": "txt_companies",
    "text": "Companies",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "txtSurveysByCompany",
    "text": "Surveys By Company",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيانات حسب الشركة"
      }
    ]
  },
  {
    "key": "txtCompanyList",
    "text": "Company List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الشركات"
      }
    ]
  },
  {
    "key": "txt_time_frame_start",
    "text": "Time Frame Start",
    "translations": [
      {
        "language": "AR",
        "text": "بداية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_time_frame_end",
    "text": "Time Frame End",
    "translations": [
      {
        "language": "AR",
        "text": "نهاية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      }
    ]
  },
  {
    "key": "txtHappinessComparisonReport",
    "text": "Happiness Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير مقارنة سعادة الموظفين"
      }
    ]
  },
  {
    "key": "txtWrongPattern",
    "text": "Email wrong pattern.",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة بريد إلكتروني خاطئة."
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      }
    ]
  },
  {
    "key": "sameDate",
    "text": "This date has already been set!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد تاريخ التذكير!"
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txtEnterInformation",
    "text": "Fill the needed information to proceed.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة المعلومات اللازمة للمتابعة."
      }
    ]
  },
  {
    "key": "txtWelcomeAboard",
    "text": "Welcome Aboard",
    "translations": [
      {
        "language": "AR",
        "text": "أهلا وسهلا بك معنا"
      }
    ]
  },
  {
    "key": "txtUsername",
    "text": "Username",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المستخدم"
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "استمر"
      }
    ]
  },
  {
    "key": "txt_required_field",
    "text": "This field is required",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الحقل إجباري"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      }
    ]
  },
  {
    "key": "txtInvitationMissingURL",
    "text": "The email is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا البريد الإلكتروني!"
      }
    ]
  },
  {
    "key": "txt_start_and_endDate",
    "text": "Please, add start date and end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة تاريخ البدء وتاريخ الانتهاء."
      }
    ]
  },
  {
    "key": "txt_no-timeframe",
    "text": "No timeframe has been chosen.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تحديد مدة زمنية"
      }
    ]
  },
  {
    "key": "txt_txt_no_respondents",
    "text": "At least one respondent needs to added to proceed!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مستجيب واحد على الأقل!"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      }
    ]
  },
  {
    "key": "txt_ID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_date_created",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      }
    ]
  },
  {
    "key": "txt_respondent_name",
    "text": "Respondent's Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      }
    ]
  },
  {
    "key": "txt_reminder_sent",
    "text": "Email sent to relevant respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال البريد الإلكتروني إلى المستجيبين المعنيين."
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Survey Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات الاستبيان"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الاستبيان"
      }
    ]
  },
  {
    "key": "txtSelectOption",
    "text": "Select Option",
    "translations": [
      {
        "language": "AR",
        "text": "اختر خيار"
      }
    ]
  },
  {
    "key": "txt_copy",
    "text": "Copy",
    "translations": [
      {
        "language": "AR",
        "text": "نسخ"
      }
    ]
  },
  {
    "key": "txtTemplateEmail",
    "text": "This template is optimized for email clients \"Gmail, Outook, ...etc\" please modify with care. If you wish to revert to the default template click on the \"Default Template\" button.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحسين هذا النموذج لمستخدمي البريد الالكتروني الخاص بـ \"Gmail, Outlook,…etc\" الرجاء التعديل بحذر. إذا كنت ترغب بالتحويل للنموذج الأساسي اضغط على زر \"النموذج الأساسي\"."
      }
    ]
  },
  {
    "key": "txtDefaultTemplate",
    "text": "Default Template",
    "translations": [
      {
        "language": "AR",
        "text": "النموذج الأساسي"
      }
    ]
  },
  {
    "key": "txt_survey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      }
    ]
  },
  {
    "key": "txt_done",
    "text": "Done",
    "translations": [
      {
        "language": "AR",
        "text": "منجز"
      }
    ]
  },
  {
    "key": "txtEngReminderSubject",
    "text": "[Reminder] IMPACT Survey 2022",
    "translations": [
      {
        "language": "AR",
        "text": "[تذكير] استبيان IMPACT 2022"
      }
    ]
  },
  {
    "key": "btn_remove",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_subject_line",
    "text": "Subject Line",
    "translations": [
      {
        "language": "AR",
        "text": "خانة العنوان"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      }
    ]
  },
  {
    "key": "txt_survey_progress",
    "text": "Survey Progress",
    "translations": [
      {
        "language": "AR",
        "text": "حالة الاستبيان"
      }
    ]
  },
  {
    "key": "btn_filter_by",
    "text": "Filter By",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب"
      }
    ]
  },
  {
    "key": "btnCloseNow",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      }
    ]
  },
  {
    "key": "txtResponded",
    "text": "Responded",
    "translations": [
      {
        "language": "AR",
        "text": "استجاب منهم"
      }
    ]
  },
  {
    "key": "txtGenerate",
    "text": "Generate",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء"
      }
    ]
  },
  {
    "key": "txtLandingPageURL",
    "text": "Survey Link",
    "translations": [
      {
        "language": "AR",
        "text": "رابط الاستبيان"
      }
    ]
  },
  {
    "key": "txtLandingPage",
    "text": "Survey Link",
    "translations": [
      {
        "language": "AR",
        "text": "رابط الاستبيان"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Survey Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الاستبيان"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      }
    ]
  },
  {
    "key": "txtExportSurvey",
    "text": "Download Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل أسئلة الاستبيان"
      }
    ]
  },
  {
    "key": "txt_happiness_preview_survey",
    "text": "Happiness Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان سعادة الموظفين"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      }
    ]
  },
  {
    "key": "txt_no_selected",
    "text": "Minimum Record is 1",
    "translations": [
      {
        "language": "AR",
        "text": "الحد الأدنى هو 1"
      }
    ]
  },
  {
    "key": "txt_already_exists",
    "text": "Already Exists",
    "translations": [
      {
        "language": "AR",
        "text": "موجود أصلاً "
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      }
    ]
  },
  {
    "key": "txtExtraQuestionMinimum",
    "text": "at least one statement needs to be added!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحد على الأقل!"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txt_drivers_score_happiness",
    "text": "Factors' Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتائج عوامل السعادة"
      }
    ]
  },
  {
    "key": "txt_Workplace_Happiness_Score",
    "text": "Workplace Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة السعادة في مكان العمل"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      }
    ]
  },
  {
    "key": "txtHappinessReport",
    "text": "Employee Happiness Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير سعادة الموظف"
      }
    ]
  },
  {
    "key": "txtHappinessScaleByDriver",
    "text": "Employee Happiness Index by Factor",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر سعادة الموظف حسب كل عامل سعادة"
      }
    ]
  },
  {
    "key": "txtHappinessScaleByCriteria",
    "text": "Employee Happiness by Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظف حسب المعايير"
      }
    ]
  },
  {
    "key": "txtQuestionsAnalysisbyDriverHappiness",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtExportCommentCheckbox",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "Happiness Level",
    "text": "Happiness Level",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس السعادة"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments Unavailable",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات غير متاحة"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      }
    ]
  },
  {
    "key": "txtRatingScale",
    "text": "Rating Scale",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس التقييم"
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "Each statement score is given an average rating based on the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب نتيجة كل عبارة من خلال أخذ متوسط نتائج اختيارات الموظفين."
      }
    ]
  },
  {
    "key": "txtHappinessCalculationProcess2",
    "text": "Each factor score is calculated as the overall rating score of the statements.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب نتيجة كل عامل من عوامل السعادة في مكان العمل من خلال أخذ متوسط نتائج العبارات. "
      }
    ]
  },
  {
    "key": "txtHappinessCalculationProcess3",
    "text": "The Overall Workplace Happiness is calculated as the average rating of the selected factors.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب مستوى سعادة الموظفين الكلي في مكان العمل من خلال أخذ متوسط نتائج عوامل السعادة في مكان العمل التي تم اختيارها."
      }
    ]
  },
  {
    "key": "txtHappinessCalculationProcess4",
    "text": "The Employee Happiness Index is calculated as per the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "يتم احتساب مؤشر سعادة الموظفين في مكان العمل من خلال نتائج اختيارات الموظفين."
      }
    ]
  },
  {
    "key": "txtEmployeesHappinessIndex",
    "text": "Employee Happiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر سعادة الموظفين"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      }
    ]
  },
  {
    "key": "Score Range",
    "text": "Score Range",
    "translations": [
      {
        "language": "AR",
        "text": "النسبة المئوية"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report?",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      }
    ]
  },
  {
    "key": "txtDefinition",
    "text": "Definition",
    "translations": [
      {
        "language": "AR",
        "text": "التعريف"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      }
    ]
  },
  {
    "key": "txtHappinessIntroductionPara",
    "text": "<p>Employee Happiness is the extent to which an employee is happy or satisfied with their work and the workplace that they are in. In other words, are they happy with their job? Are they happy with the work environment and atmosphere?</p>  <br> <p>Happiness is considered a powerful motivator that encourages employees to perform harder and invest more effort in achieving business goals in addition to its essential role in improving retention and promoting a driven workplace culture.</p> <br>  <p>This Employee Happiness Survey applies the 6Cs Model to measure employees’ happiness and satisfaction at the workplace, displayed in this report through in-depth analysis, scores, and recommendations.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>سعادة الموظف هي مدى سعادة الموظف أو رضاه عن عمله ومكان العمل الذي يتواجد فيه. بمعنى آخر ، هل هم سعداء بوظيفتهم؟ هل هم سعداء ببيئة العمل والجو العام؟</p> <br> <p>تعتبر السعادة حافزاً قوياً يشجع الموظفين على العمل بجدية أكبر واستثمار المزيد من الجهد في تحقيق أهداف العمل، بالإضافة إلى دورها الأساسي في تحسين معدل الاحتفاظ بالموظفين وتعزيز ثقافة مكان العمل.</p> <br>  <p>يُطبق استبيان سعادة الموظف \"نموذج6Cs \" لقياس مدى سعادة الموظفين ورضاهم في مكان العمل، والذي يتم عرضه في هذا التقرير من خلال التحليل المتعمق والنتائج المفصّلة والتوصيات.</p>"
      }
    ]
  },
  {
    "key": "txtHappinessObjectives",
    "text": "\n  <h4 class=\"mb-5 fw-bold\">Objectives of this Report</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify the overall workplace happiness score and understand how happy and unhappy employees affect the workplace and its overall performance.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Identify the factors that retain your employees and keep them happy.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Understand areas of improvement through factors with a low happiness score and the reason behind such a score.</p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Access recommended actions to be taken for each factor, regardless of the happiness score, to improve your environment at work.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of doing things, and understand how they feel about the workplace.</p>\n      </li>\n    </ul>\n  </div>\n</div> ",
    "translations": [
      {
        "language": "AR",
        "text": "\n  <h4 class=\"mb-5 fw-bold\">أهداف التقرير</h4>\n  <div class=\"columns-content\">\n  <div class=\"col-left\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد درجة السعادة الوظيفية الإجمالية في مكان العمل وفهم كيف يؤثر الموظفون السعداء وغير السعداء على مكان العمل وأدائه الكلي.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد العوامل التي تجعل الموظفين سعداء مما يساعد على الاحتفاظ بهم.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>تحديد نقَاط التحسين عن طريق العوامل ذات السعادة المتدنية والأسباب وراء هذه النتائج.</p>\n      </li>\n    </ul>\n  </div>\n  <div class=\"col-sep\"></div>\n  <div class=\"col-right\">\n    <ul>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على توصيات لأخذها بعين الاعتبار لكل عامل، بغض النظر عن درجة السعادة الخاصة به وكيفية تطبيق هذه التوصيات لتحسين بيئة ومكان العمل.</p>\n      </li>\n      <li>\n        <i class=\"fas fa-circle\"></i>\n        <p>الحصول على تعليقات الموظفين من خلال الاستبيان، للاستفادة منها في تطوير طرق تنفيذ الأعمال، وفهم شعور الموظفين تجاه مكان العمل. </p>\n      </li>\n    </ul>\n  </div>\n</div> "
      }
    ]
  },
  {
    "key": "txt6CModelbyZENITHR",
    "text": "The 6Cs Model by Zenithr",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج 6Cs - زينثر"
      }
    ]
  },
  {
    "key": "txtHappinessScience",
    "text": "The Story Behind the 6Cs Model",
    "translations": [
      {
        "language": "AR",
        "text": "العلم الذي يرتكز عليه نموذج  6Cs"
      }
    ]
  },
  {
    "key": "txtHappinessSciencePara",
    "text": "<p class=\"mb-4\">Building ground above our research and influential names, Zenithr’s research team has selected the best factors that affect employees’ happiness and satisfaction and lead to their retention. The selection ranged from top-rated universities, organizations, and workplaces that revealed a positive correlation between employee happiness and a thriving, performance-driven culture. The availability of multiple factors that drive satisfaction has provided Zenithr with the ability to carefully pluck out those that measure employee happiness using various factors that begin with the same letter, C.</p>  <p class=\"mb-4\">The 6Cs, influenced by the latest scientific practices, research, and recent business trends, have been modeled to represent the research conducted. It constitutes multiple factors named Culture, Compensation, Connection, Conditions, Career Advancement, and Continuity. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">بناءً على الأبحاث التي قمنا بها والدراسات التابعة لخبراء مختصين، قام فريق البحث في زينثرباختيار أفضل العوامل التي تؤثر على سعادة الموظفين ورضاهم وبالتالي الاحتفاظ بهم. وقد ارتكز البحث على نطاق واسع من جامعات ذات تصنيف عالي، ومؤسسات، وأماكن عمل كشفت عن وجود علاقة إيجابية بين سعادة الموظف والثقافة المبنية على الأداء. إن توافر العديد من العوامل التي تدفع بالرضا جعل زينثرتستخلص تلك العوامل التي تقيس سعادة الموظف باستخدام مجموعة مختلفة من العوامل تبدأ بالحرف نفسه \"C\".</p>  <p class=\"mb-4\">تم تصميم نموذج 6Cs لتمثيل البحث الذي تم إجراؤه والذي يرتكز على أحدث الممارسات والأبحاث واتجاهات الأعمال الحديثة والذي يهدف إلى تحقيق بيئة عمل سعيدة. ويشكل عدة عوامل هي:  الثقافة، والتعويضات، والتواصل، وظروف العمل، والتطور الوظيفي، والاستمرارية.</p>"
      }
    ]
  },
  {
    "key": "txtHappinessHowToUseThisReportPara",
    "text": "<p class=\"mb-4\">This report is a representation of the current level of happiness at [Company Name]. The overall happiness score will help understand how the employees feel across the workplace.</p>\n  <p class=\"mb-4\">The factors and their happiness levels displayed in this report are a result of the employees’ responses. Below every score is the analysis of the employees’ happiness with this specific factor at the workplace.</p>\n  <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the environment, and they are not limited to the displayed suggestions. It is highly encouraged that the actions deemed fit for [Company Name] are considered to improve their employees’ happiness levels.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">يوضح هذا التقرير المستوى الحالي للسعادة الوظيفية في [Company Name]. وسوف تساعد النتيجة الإجمالية للسعادة في فهم شعور الموظفين في مكان العمل.</p>\n  <p class=\"mb-4\">إن عوامل السعادة المبينة في هذا التقرير ومستوى السعادة الخاص بها هي نتيجة وخلاصة استجابة الموظفين لهذا الاستبيان. ويلي كل نتيجة، تحليل خاص بسعادة الموظفين حسب كل عامل ومدى ارتباطه في مكان العمل.</p>\n  <p class=\"mb-4\">إن الإجراءات الموصى بها في هذا التقرير ما هي إلا جزء من الإجراءات التي من الممكن اتخاذها في تحسين بيئة العمل، ولا تقتصر عليها فقط. وتشجع على اتخاذ الإجراءات المناسبة لتحسين مستوى السعادة الوظيفية الخاص بـ[Company Name].</p>"
      }
    ]
  },
  {
    "key": "txtFactorsofWorkplaceHappiness",
    "text": "Workplace Happiness Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل السعادة في مكان العمل"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceHappiness",
    "text": "Overall Workplace Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "السعادة الوظيفية الكلية في مكان العمل"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceHappinesspara1",
    "text": "The Workplace Happiness Score measures the overall happiness across the workplace. It is the average score of all the factors combined.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة السعادة الوظيفية في مكان العمل عن الرضى والسعادة الكلية في مكان العمل. وهي تشكل المعدل الكلي لنتائج عوامل السعادة."
      }
    ]
  },
  {
    "key": "txtEmployeesHappinessIndexpara",
    "text": "The Employee Happiness Index is the next level of the workplace happiness score. The below results represent the happiness and satisfaction levels of your employees:",
    "translations": [
      {
        "language": "AR",
        "text": "وتعرض النتائج أدناه، النسب المئوية التي تمثل الوضع الحالي لمستويات السعادة والرضا للموظفين: "
      }
    ]
  },
  {
    "key": "txtExtremelyHappyDesc",
    "text": "[Percentage]% of the participated employees are extremely happy with their job and the workplace. These employees are driven to do more than what is expected of them as they are rewarded and recognized for their effort.  They will continue to outperform in the tasks given to them and accomplish more achievements and successes and contribute to improving workplace culture and overall performance.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين المشاركين سعداء للغاية بوظائفهم ومكان عملهم. لدى هؤلاء الموظفين الدافع للقيام بأكثر مما هو متوقع منهم نتيجة مكافئتهم وتقديرهم المستمر على جهودهم، وبالتالي سيواصلون التفوق في المهام الموكلة إليهم وتحقيق إنجازات ونجاحات أكثر، كما يساهمون في تحسين أداء وثقافة مكان العمل."
      }
    ]
  },
  {
    "key": "txtHappyDesc",
    "text": "[Percentage]% of the participated employees are happy with their job and the workplace. These employees are motivated and encouraged to do more than what is expected of them as they are rewarded and recognized for their effort. They contribute to accomplishing more achievements and successes.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين المشاركين سعداء بوظائفهم ومكان عملهم. لدى هؤلاء الموظفين الحافز الكافي للقيام بأكثر مما هو متوقع منهم نتيجة مكافئتهم وتقديرهم المستمر على جهودهم، وبالتالي يساهمون في تحقيق إنجازات ونجاحات أكثر وتحسين أداء وثقافة مكان العمل."
      }
    ]
  },
  {
    "key": "txtUnHappyDesc",
    "text": "[Percentage]% the participated employees are unhappy with their job and the workplace. They feel demotivated and less likely to improve workplace culture and overall performance because they do not feel sufficiently appreciated and rewarded for their work. This category of employees needs more recognition of their progress, encouragement, and support to be happier and satisfied.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين المشاركين غير سعداء بوظائفهم ومكان عملهم. يشعر هؤلاء الموظفين بالإحباط ولا يوجد لديهم ميول للمساهمة في تحسين ثقافة مكان العمل وأدائه نتيجة عدم شعورهم بالتقدير الكافي لأعمالهم ومكافأتهم عليها.\n\n  تحتاج هذه الفئة من الموظفين إلى مزيد من التقدير والتشجيع والدعم المستمر ليكونوا أكثر سعادة ورضا.\n  "
      }
    ]
  },
  {
    "key": "txtExtremelyUnHappyDesc",
    "text": "[Percentage]% of the participated employees are extremely unhappy with the workplace. They feel extremely demotivated and do not contribute to improving workplace culture and overall performance because they do not feel sufficiently appreciated and rewarded for their work. This category of employees needs more recognition of their progress, encouragement, and support to be happier and satisfied.",
    "translations": [
      {
        "language": "AR",
        "text": "[Percentage]% من الموظفين المشاركين غير سعداء للغاية بوظائفهم ومكان عملهم. يشعر هؤلاء الموظفين بالإحباط الشديد وليس لديهم ميول للمساهمة في تحسين ثقافة مكان العمل وأدائه نتيجة عدم شعورهم بتقدير أعمالهم ومكافأتهم عليها.\n\n  تحتاج هذه الفئة من الموظفين إلى مزيد من التقدير والتشجيع والدعم المستمر ليكونوا أكثر سعادة ورضا.\n  "
      }
    ]
  },
  {
    "key": "txtFactorsofWorkplaceHappinessDesc",
    "text": "The below indicates the scores for each of the [Drivers Count] factors of Workplace Happiness at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يوضح التالي النتائج لكل من ال[Drivers Count] عوامل السعادة في مكان العمل في [Company Name]:"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceHappinessScore",
    "text": "Overall Workplace Happiness Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة السعادة الوظيفية الكلية في مكان العمل"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      }
    ]
  },
  {
    "key": "txtResponses2",
    "text": "Responses",
    "translations": [
      {
        "language": "AR",
        "text": "الردود"
      }
    ]
  },
  {
    "key": "txtOutOf",
    "text": "out of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون"
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txtEmployeeHappiness",
    "text": "Employee Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظف"
      }
    ]
  },
  {
    "key": "txtFactors",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "العوامل"
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": "I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في بيئة العمل"
      }
    ]
  },
  {
    "key": "txt4Questions",
    "text": "You can add up to 4 statements",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إضافة ٤ عبارات بحد أقصى"
      }
    ]
  },
  {
    "key": "txt_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق"
      }
    ]
  },
  {
    "key": "txtCustomFactorText",
    "text": "Create and customize your own factor with up to custom 5 questions",
    "translations": [
      {
        "language": "AR",
        "text": "أنشئ وخصص عامل السعادة الخاص بك مع 5 أسئلة كحد أقصى"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Factor Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العامل"
      }
    ]
  },
  {
    "key": "txtCustomfactor",
    "text": "Add Custom Factor?",
    "translations": [
      {
        "language": "AR",
        "text": " أضف عامل سعادة مخصص"
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      }
    ]
  },
  {
    "key": "btn_add_question",
    "text": "Add Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة"
      }
    ]
  },
  {
    "key": "txtTypeComment",
    "text": "Type your comment here ...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب اقتراحك هنا …"
      }
    ]
  },
  {
    "key": "Top Performers",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "هل لديك أي تعليق ؟"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Survey Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد الاستبيان"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال الاستبيان"
      }
    ]
  },
  {
    "key": "txt_title",
    "text": "title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "txt_description",
    "text": "Description (Optional)",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "txt_type_description",
    "text": "text here…",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب هنا..."
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Survey",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الاستبيان"
      }
    ]
  },
  {
    "key": "txt_new_criteria",
    "text": "New Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معيار جديد"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة الاستبيان قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      }
    ]
  },
  {
    "key": "txt_send_to",
    "text": "Send To",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال إلى"
      }
    ]
  },
  {
    "key": "txt_message_body",
    "text": "Body",
    "translations": [
      {
        "language": "AR",
        "text": "نص الرسالة"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      }
    ]
  },
  {
    "key": "btn_expand",
    "text": "EXPAND",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      }
    ]
  },
  {
    "key": "btn_collapse",
    "text": "COLLAPSE",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      }
    ]
  },
  {
    "key": "txt_answers",
    "text": "Options",
    "translations": [
      {
        "language": "AR",
        "text": "الإجابات"
      }
    ]
  },
  {
    "key": "txt_answers_description",
    "text": "Options will be shown in a drop down list. A respondent may select only one option.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم عرض الإجابات كخيارات (سيتم اختيار إجابة واحدة فقط من قبل المستجيب)"
      }
    ]
  },
  {
    "key": "btn_save_criteria",
    "text": "Save Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ المعايير"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      }
    ]
  },
  {
    "key": "txtQAnswer",
    "text": "text here…",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب هنا..."
      }
    ]
  },
  {
    "key": "txtCriteriaName",
    "text": "Criterion Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المعيار"
      }
    ]
  },
  {
    "key": "txt_email_address",
    "text": "Email Address",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الالكتروني"
      }
    ]
  },
  {
    "key": "txtex",
    "text": "Ex. Mia",
    "translations": [
      {
        "language": "AR",
        "text": "مثال: محمد"
      }
    ]
  },
  {
    "key": "txtConnection",
    "text": "Connection",
    "translations": [
      {
        "language": "AR",
        "text": "الاتصال"
      }
    ]
  },
  {
    "key": "txtType",
    "text": "Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع"
      }
    ]
  },
  {
    "key": "txt6csModel",
    "text": "THE 6C's MODEL",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الـ 6C's"
      }
    ]
  },
  {
    "key": "txtCulture",
    "text": "Culture",
    "translations": [
      {
        "language": "AR",
        "text": "الثقافة"
      }
    ]
  },
  {
    "key": "txtCompensation",
    "text": "Compensation",
    "translations": [
      {
        "language": "AR",
        "text": "التعويضات"
      }
    ]
  },
  {
    "key": "txtCareerAdvancement",
    "text": "Career Advancement",
    "translations": [
      {
        "language": "AR",
        "text": "التطور الوظيفي"
      }
    ]
  },
  {
    "key": "txtConditions",
    "text": "Conditions",
    "translations": [
      {
        "language": "AR",
        "text": "ظروف العمل "
      }
    ]
  },
  {
    "key": "txtContinuity",
    "text": "Continuity",
    "translations": [
      {
        "language": "AR",
        "text": "الاستمرارية في العمل"
      }
    ]
  },
  {
    "key": "txt6csModel",
    "text": "THE 6C's MODEL",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الـ 6C's"
      }
    ]
  },
  {
    "key": "txt6CsTemplate",
    "text": "6C's Template",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة نموذج الـ 6C's"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "btn_relaunch",
    "text": "Relaunch",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة إطلاق"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      }
    ]
  },
  {
    "key": "txt_one_respondent_needed",
    "text": "At least one respondent needs to complete the survey to close",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يتم إكمال الاستبيان من مستجيب واحد على الأقل لإغلاق الاستبيان"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_subject",
    "text": "Delete Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد الحذف"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      }
    ]
  },
  {
    "key": "txt_happiness_report_export",
    "text": "Happiness Survey Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير استبيان سعادة الموظف"
      }
    ]
  },
  {
    "key": "preparingReport",
    "text": "Preparing Report",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التقرير"
      }
    ]
  },
  {
    "key": "txtEngagementScale",
    "text": "Employee Happiness Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر سعادة الموظفين"
      }
    ]
  },
  {
    "key": "txtCultureDriverDesc",
    "text": "Managerial and leadership daily activities, work practices, and their accustomed policies conducted by workplaces are directly influenced by the work culture and its influence over employees' personal, professional, and peer to peer communication behavior. Thus, accommodating for an empowering and supportive work environment alongside providing a flexibly regulated, satisfactory, and joyful atmosphere positively reflects the employees’ performance by unifying their efforts and willingness to achieve expected goals while attracting and retaining high caliber qualifications.\n\n  Conclusively: the existence of a positive culture in the workplace is vital, adding specialness to its vibe while granting the employees an identity to a place they belong, are loyal to, and take pride in being a part of, thus driving their hard-working, cooperative work ethic for the prosperity of their workplace.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تؤثر ثقافة العمل بشكل مباشرا على الأنشطة اليومية الممارسة داخل أماكن العمل ان كانت الإدارية، القيادية أم على ممارسات العمل وسياساته المتبعة. كما تؤثر ثقافة العمل على سلوك الموظفين على الصعيدين المهني والشخصي، وعلى سلوكه في التعامل مع زملائه، ولذلك فإن تهيئة بيئة عمل تمكينية ساندة وتوفير أجواء عامة منظمة ومرنة تمنح الموظفين شعوراً بالرضا والسعادة وتنعكس إيجابيا على أدائهم من خلال توحيد الجهود والرغبة لدى كافة الموظفين في العمل على تحقيق الأهداف المرصودة والتطلعات المستقبلية، إضافته لمساهمتها في استقطاب الكفاءات العالية والاحتفاظ بها.\n\n  وبالخلاصة: تعد الثقافة الإيجابية في مكان العمل أمراً حيوياً تجعله مميزاً وتمنح كافة الموظفين إحساساً بالهوية مما يعزز شعورهم بالانتماء والولاء لمكان عملهم وإحساسهم بالفخر كونهم جزءاً من هذا المكان، مما يدفعهم للعمل بجهد وتكاتف في سبيل إنجاحه.\n    "
      }
    ]
  },
  {
    "key": "txtCultureActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve culture that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين ثقافة العمل:"
      }
    ]
  },
  {
    "key": "txtCultureActionDescription_1",
    "text": "Continuously provide support for extracurricular initiatives and activities that enhance the employees’ well-being that differs from routine ones that the employees have been accustomed to. This provides a sense of enjoyment and fulfillment inside the workplace and enriches non-work-related social relationships within boundaries.",
    "translations": [
      {
        "language": "AR",
        "text": "الحرص الدائم على توفير الدعم لكافة المبادرات والأنشطة التي تتعلق برفاهية الموظفين من خلال الخروج عن الرتابة والعادات المعتادة لإضفاء شعور بالراحة والاستمتاع داخل مكان العمل، وتوطيد العلاقات الاجتماعية خارج إطار العمل ضمن المقبول."
      }
    ]
  },
  {
    "key": "txtCultureActionDescription_2",
    "text": "Share and celebrate personal and group success to create and enrich a family-like work environment. This is done by sharing success stories via internal communication channels or events to celebrate, acknowledge, and show gratitude for employees’ efforts.",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة النجاحات الفردية والجماعية المهنية منها والشخصية والاحتفال بها بهدف خلق شعور عائلي في بيئة العمل. وغرس روح الإنتماء من خلال تبادل قصص النجاح عبر وسائل التواصل الداخلية في مكان العمل، أو عمل احتفال خاص بالمناسبة للثناء على الزملاء المجتهدين والاعتراف بجهودهم."
      }
    ]
  },
  {
    "key": "txtCultureActionDescription_3",
    "text": "Actively listen to the employees’ ideas and suggestions, which results in a state of intellectual and emotional infusion; thus, it will positively impact their productivity and level of accountability in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من خلق حالة من الاندماج والتوافق العاطفي والفكري عند الموظف من خلال الاستماع باستمرار لأفكاره والترحيب باقتراحاته وتقديم الدعم اللازم لتنفيذ الاقتراحات المجدية مما ينعكس ايجابياً على انتاجيته وشعوره بالمسؤولية تجاه نجاح مكان عمله. "
      }
    ]
  },
  {
    "key": "txtCultureActionDescription_4",
    "text": "Ensure integrating employees of different skill calibers while using on-the-job learning, follow-up, and mentoring methods, ensuring knowledge exchange, and strengthening employee relations within work teams.",
    "translations": [
      {
        "language": "AR",
        "text": "الحرص على تشارك الخبرات والمعرفة ضمن أفرقة العمل من خلال دمج الموظفين الجدد والأقل خبرة بالموظفين من ذوي الخبرة واستخدام أساليب التعلم من خلال العمل والمتابعة والتوجيه مما يضمن تبادل المعرفة وتعزيز العلاقات بين الموظفين."
      }
    ]
  },
  {
    "key": "Total Respondents should be at least 3 Respondents",
    "text": "Total Respondents should be at least 3 Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع عدد المستجيبين 3 على الأقل"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "txt_resp_by_age_group",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "txt_resp_by_tenure_group",
    "text": "Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txtRespbygender",
    "text": " Gender",
    "translations": [
      {
        "language": "AR",
        "text": " الجنس"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب "
      }
    ]
  },
  {
    "key": "txtOveralleng",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "المعدل الكلي"
      }
    ]
  },
  {
    "key": "txtRespbynationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "txtCultureExtremelyUnhappyDriverRecommendation",
    "text": "This result indicates that employees are extremely unhappy and dissatisfied with the culture. Their loyalty levels are dangerously low. Additionally, they are unhappy with the encouragement and support provided for them to achieve the adequate level of the business’s goals and requirements; thus, they require immediate support to tackle the reasons behind their overall unhappiness and distress.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفون لا يشعرون أبداً بأي نوع من أنواع الرضا والارتياح بالثقافة السائدة، ويشعرون بالاستياء الشديد حيالها، كما أنهم غير راضيين عن التشجيع والدعم المقدم لهم لتلبية متطلبات وأهداف العمل ولذلك هم بحاجة إلى المساندة الفورية لفهم أسبابهم ومعالجتها."
      }
    ]
  },
  {
    "key": "txtCultureUnhappyDriverRecommendation",
    "text": "This result indicates that employees are unhappy and dissatisfied with the culture; they don’t possess sufficient loyalty. Additionally, they tend to be unhappy with the encouragement and support provided to achieve the business’s goals and requirements; thus, they need further help through discussions to tackle the reasons behind their overall unhappiness and distress.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفون لا يشعرون بالرضا والارتياح بالثقافة السائدة ويشعرون بالاستياء حيالها، كما أنهم لا يشعرون بالانتماء والولاء لأماكن عملهم، وغير راضيين عن التشجيع والدعم المقدم لهم لتلبية متطلبات وأهداف العمل، ولذلك هم بحاجة للمزيد من المساندة لفهم أسبابهم ومعالجتها."
      }
    ]
  },
  {
    "key": "txtCultureHappyDriverRecommendation",
    "text": "This result indicates that employees are happy and satisfied with the culture, with a high level of affiliation, loyalty, and taking pride in being a part of the workplace. They achieve the required goals with relative ease. They are rewarded with the encouragement and inspiration needed accordingly while collaboratively executing prosperous best practices with devotion and dedication to their workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفون يشعرون بالرضا والارتياح بالثقافة السائدة ويشيدون بها، كما أنهم يشعرون بالانتماء والولاء والفخر كونهم جزءاً من هذا المكان، ويحصلون على بعض التشجيع والإلهام اللازم لتلبية متطلبات وأهداف العمل، ويؤمنون بالعمل التشاركي والمشاورة للوصول إلى أفضل الأساليب التي تحقق النجاح والازدهار لأماكن عملهم."
      }
    ]
  },
  {
    "key": "txtCultureExtremelyHappyDriverRecommendation",
    "text": "This result indicates that employees are extremely happy and satisfied with the culture, alongside feeling a high level of affiliation, loyalty, and taking pride by being a part of the workplace. They achieve the required goals with ease. They are rewarded with the encouragement and inspiration needed while collaboratively executing best practices with devotion and dedication to their workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفون يشعرون بالرضا والارتياح التام بالثقافة السائدة ويشيدون بها، كما أنهم يشعرون بالانتماء والولاء والفخر كونهم جزءاً من هذا المكان، ويحصلون على التشجيع والإلهام اللازم لتلبية متطلبات وأهداف العمل، ويؤمنون بالعمل التشاركي والمشاورة للوصول إلى أفضل الأساليب التي تحقق النجاح والازدهار لأماكن عملهم."
      }
    ]
  },
  {
    "key": "txtCompensationDriverDesc",
    "text": "The compensations package offered to employees directly impacts the employees’ satisfaction and well-being and their work dedication and commitment. Thus, resulting in a higher drive in their efforts to attain accomplishments within their scope of work due to their belief of being compensated accordingly. Therefore, workplaces could execute clear and fair compensation schemes that achieve equality between employees internally and externally within the job market that aids in higher retention rates, attracts exceptional talents, and motivates the employees to be more productive.\n\n  Conclusively: the employees’ compensation and benefits packages granted in return for achieving their workplace’s goals are considered as a key pillar for improving their happiness, which in return improves their job satisfaction, efficiency, and productivity, in addition to lowering absence and resigning incidences.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تحظى مجموعة التعويضات المقدمة للموظفين بتأثير مباشر على سعادة ورضا الموظفين ومدى ارتباطهم وإخلاصهم لأعمالهم. كما تدفعهم إلى بذل المزيد من الجهد لتحقيق المزيد من النجاح في مكان عملهم لقناعتهم بأنهم سيحصلون على التعويض والتقدير مقابل الجهد والإنجاز المبذول. لذلك قد ترغب أماكن العمل في تنفيذ برامج تعويضات ومكافآت واضحة وعادلة تحقق المساواة الداخلية بين الموظفين، وتمنحهم المساواة الخارجية مع سوق العمل والذي من شأنه أيضاً الاحتفاظ بالموظفين الحاليين واجتذاب الكفاءات والمواهب الاستثنائية وتحفيز الموظفين على السعي لتحقيق مستويات أعلى من الإنتاجية.\n\n  وبالخلاصة: تعد مجموعة التعويضات والمزايا الممنوحة للموظفين مقابل مساهماتهم في تحقيق أهداف مكان عملهم أحد أبرز أسباب سعادة الموظف والتي تؤثر في تعزيز الرضا الوظيفي وزيادة الكفاءة والإنتاجية في العمل، كما تُسهم في تقليل غياب الموظفين وتقليل حالات ترك العمل.\n  "
      }
    ]
  },
  {
    "key": "txtCompensationActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve compensation and benefits schemes that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين مجموعة التعويضات والمزايا:"
      }
    ]
  },
  {
    "key": "txtCompensationActionDescription_1",
    "text": "Grant attractive and competitive compensation and rewards programs by conducting periodical market studies that assess the industry’s compensation and benefits schemes considering various factors such as employees’ age, job level, personal life, and perhaps age and social status to motivate them to achieve more progress and success",
    "translations": [
      {
        "language": "AR",
        "text": "منح برامج تعويضات ومزايا جاذبة وتنافسية من خلال مسح ودراسة برامج التعويضات الممنوحة في الأسواق المحلية بشكل دوري واختيار البرامج المناسبة لكل موظف مع الأخذ بعين الاعتبار عوامل متعددة مثل درجته الوظيفية وحياته الشخصية وربما عمره ووضعه الاجتماعي، لتحفيزهم لتحقيق المزيد من التقدم والنجاح."
      }
    ]
  },
  {
    "key": "txtCompensationActionDescription_2",
    "text": "Appreciate and value employees’ accomplishments through monetary and non-monetary compensations and rewards, i.e., salary incrementation, short- and long-term incentives. Additionally, provide non-monetary recognition programs such as appreciation, gratitude, achievement letters, and creative employee and employee of the month initiatives.",
    "translations": [
      {
        "language": "AR",
        "text": "تقدير وتثمين الإنجازات المبذولة من قبل الموظفين من خلال منح التعويضات والمكافآت المادية استحقاقاً لجهودهم مثل زيادة على الراتب الأساسي، ومنح الحوافز قصيرة وطويلة الأجل، وربما بعض المكافآت المادية المخصصة لذلك الموظف بناءً على تفضيلاته، إضافة إلى منح التعويضات المعنوية مثل رسائل الشكر والتقدير اللفظي والبرامج المحفزة مثل (الموظف المثالي والموظف المبدع)، وغيرها."
      }
    ]
  },
  {
    "key": "txtCompensationActionDescription_3",
    "text": "Create a compensation and benefits scheme that is designed specifically in reference to each employee’s scope of work, responsibility, role, and job level, including housing allowance, transportation allowance, education allowance, telephone allowance, and travel allowance on top of employee and family health insurance, life insurance as primary benefits which provides the employee with a sense of stability, security, and responsibility towards improving upon their workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص برامج مزايا وبدلات تتناسب مع طبيعة العمل والدور والمسؤوليات التي يقوم بها الموظف والدرجة الوظيفية والتي تشمل (بدل مواصلات، وبدل سكن، وبدل تعليم، وبدل هاتف، وبدل السفر) إضافة إلى المزايا الأساسية مثل التأمين الصحي للموظفين ولأفراد أسرهم وربما لأفراد أسرهم، وتأمين الحياة مما يعزز شعور الموظف بالاستقرار والأمن الوظيفي وشعوره بالمسؤولية تجاه تطور مكان عمله واستمراريته."
      }
    ]
  },
  {
    "key": "txtCompensationActionDescription_4",
    "text": "Create a unique compensation scheme to distinguish the workplace from others, giving it a competitive advantage that attracts and maintains talent such as exceptional holidays in certain circumstances that do not conflict with work requirements, gifting during social and religious events, and offering provident fund programs.",
    "translations": [
      {
        "language": "AR",
        "text": "ابتكار برامج تعويضات مميزة ينفرد فيها مكان العمل عن باقي المؤسسات مما يكسبه ميزة تنافسية تساهم في استقطاب الكفاءات والمحافظة عليهم مثل منح عطلات استثنائية في ظروف معينة بما لا يتعارض مع متطلبات العمل، أو إهدائهم بعض الهدايا الرمزية في المناسبات الاجتماعية أو الدينية، أو برامج صندوق الادخار. "
      }
    ]
  },
  {
    "key": "txtCompensationExtremelyUnhappyDriverRecommendation",
    "text": "This result indicates that employees are extremely dissatisfied with the compensation, benefits, and allowances schemes, and all their efforts are not appreciated nor recognized. They do not hold an obligation or responsibility towards their workplace's success and growth, thus requiring an immediate restructuring of their schemes.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين مستاءين جداً مما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، ويشعرون بأن جهودهم المبذولة في عملهم لا يتم مقابلتها بالتقدير أبداً، ولا يشعرون بالالتزام والمسؤولية حيال نجاح وازدهار مكان عملهم، ويحتاجون إلى إعادة النظر الفورية في المكافآت والمزايا الممنوحة لهم."
      }
    ]
  },
  {
    "key": "txtCompensationUnhappyDriverRecommendation",
    "text": "This result indicates that employees are dissatisfied with the compensation, benefits, and allowances schemes, and their efforts are underappreciated. They do not hold an obligation or responsibility towards their workplace's success, growth; thus, they require re-evaluating their schemes.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين مستاءين مما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، ويشعرون بأن جهودهم المبذولة في عملهم لا يتم مقابلتها بالتقدير، ولا يشعرون بالالتزام والمسؤولية حيال نجاح وازدهار مكان عملهم، ويحتاجون إلى إعادة النظر في المكافآت والمزايا الممنوحة لهم."
      }
    ]
  },
  {
    "key": "txtCompensationHappyDriverRecommendation",
    "text": "This result indicates that employees are relatively fulfilled and satisfied with the compensation, benefits, and allowances schemes, and most of their efforts are appreciated. They feel obliged, committed, and responsible for attaining business growth and achieving its goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين يشعرون بالقناعة والرضا إلى حد ما عما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، وبأن معظم جهودهم المبذولة في عملهم يتم مقابلتها بالتقدير. كما يشعرون بالالتزام والمسؤولية تجاه تحقيق أهداف العمل ونموه."
      }
    ]
  },
  {
    "key": "txtCompensationExtremelyHappyDriverRecommendation",
    "text": "This result indicates that employees are absolutely fulfilled and satisfied with the compensation, benefits, and allowances schemes, and their efforts are fully appreciated. They feel fully obliged, committed, and responsible for attaining business growth and achieving its goals.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين يشعرون بالقناعة التامة والرضا عما يحصلون عليه من تعويضات ومزايا وبدلات ممنوحة، وبأن كافة جهودهم المبذولة في عملهم يتم مقابلتها بالتقدير على أكمل وجه. كما يشعرون بالالتزام والمسؤولية تجاه تحقيق أهداف العمل ونموه."
      }
    ]
  },
  {
    "key": "txtCommunicationDriverDesc",
    "text": "Effective communication at workplaces is an important matter and a constructive tool for the employee's job-related happiness. It optimizes work by reducing doubts, confusion, the misconception of information, and mistakes derived from poor communication, resulting in demotivation and self-doubt. Effective communication is a core pillar towards building good, long-lasting relations between the management and their subordinates that improve productivity due to a clear understanding of the roles and responsibilities of each to achieve the workplace's goals.\n\n  Conclusively: Effective communication constructs a more productive, open environment than in closed one’s that drives qualifications out, resulting in higher employees’ turnover as a result of the employee’s lack of sense of belonging and loyalty and the inexistence of cooperation and responsibility, thus the absence of job happiness.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "يُعد التواصل الفعّال في مكان العمل أمر في غاية الأهمية وأداة فعالة في شعور الموظف بالسعادة الوظيفية، حيث يساهم التواصل الفعّال في تحقيق الفهم والحد من التشتيت والتخمين والتفسير الشخصي وتقليل الأخطاء الناجمة عن سوء التواصل والتي قد تؤدي إلى شعور الموظف بالإحباط وقلة الثقة بالنفس والاستياء. كما يساهم التواصل الفعّال في بناء علاقات جيدة بين الرؤساء ومرؤوسيهم وزيادة إنتاجيتهم نتيجة الفهم الواضح والمشترك للأدوار والمسؤوليات المطلوبة من كل فرد لتحقيق أهداف العمل.\n\n\n  وبالخلاصة: يساهم التواصل الفعّال في خلق بيئة عمل أكثر إنتاجية وأكثر انفتاحاً عنها في بيئات العمل المنغلقة الطاردة للكفاءات والتي تزداد فيها معدلات الدوران الوظيفي نتيجة لعدم شعور الموظف بالانتماء والولاء لمكان العمل وانعدام روح المسؤولية والتشاركية وبالتالي انعدام السعادة الوظيفية.\n      "
      }
    ]
  },
  {
    "key": "txtCommunicationActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve the communication that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين التواصل:"
      }
    ]
  },
  {
    "key": "txtCommunicationActionDescription_1",
    "text": "Ensure the implementation of the (Open-Door Policy) in the essence of its huge role of strengthening communication among employees while supporting transparency and freedom of speech principles.",
    "translations": [
      {
        "language": "AR",
        "text": "الاستمرار بتبني سياسة الباب المفتوح (open-door policy) لما لها من دور كبير في تعزيز التواصل بين الموظفين، ومن المهم دعم مبدأ الشفافية والسماح للموظفين بالتعبير عن آرائهم بحرية دون خوف."
      }
    ]
  },
  {
    "key": "txtCommunicationActionDescription_2",
    "text": "Ensure communicating with employees while sharing expertise and previous experiences, lessons learned, successes while clarifying how to overcome possible challenges and obstacles smoothly.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكيد على التواصل مع الموظفين ومشاركة الخبرات والتجارب السابقة والتحدث معهم حول الإنجازات والأخطاء وتوضيح كيف يمكنهم التعامل مع الصعوبات والتحديات التي قد تواجههم بسلاسة."
      }
    ]
  },
  {
    "key": "txtCommunicationActionDescription_3",
    "text": "Ensure the empowerment of communication between the top management and their subordinates by visiting their offices, exchange greetings, and having small chats that do not revolve around work precisely. This signifies the positive vibe in the workplace and shows appreciation and caring towards employees seeking this type of care.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكيد على تعزيز التواصل بين الإدارة العليا والموظفين من خلال التجول بين مكاتب الموظفين وتبادل التحيات وإجراء محادثة قصيرة معهم بين حين وآخر وسؤالهم عن أحوالهم، وهذا يعبر عن إيجابية المكان ويوجه رسالة تقدير للموظف الذي يبحث عن الاهتمام. "
      }
    ]
  },
  {
    "key": "txtCommunicationActionDescription_4",
    "text": "Continuously conduct periodic meetings with the employees to share and discuss work-related updates and anticipated challenges to signify the importance of employee involvement with their propositions, opinions, and ideas.",
    "translations": [
      {
        "language": "AR",
        "text": "الاستمرار بعقد اجتماعات منتظمة مع الموظفين ومشاركة الأمور المتعلقة بالعمل والتطورات والتحديات المتوقعة حيث من شأن ذلك التنويه على أهمية مشاركة الموظفين آرائهم واقتراحاتهم."
      }
    ]
  },
  {
    "key": "txtCommunicationActionDescription_5",
    "text": "Optimize communication and social engagement within and outside the workplace premises by including social events such as having lunch together as a team, meetups, or implementing other events or ideas that encourage informal and friendly talks and relationships among employees.",
    "translations": [
      {
        "language": "AR",
        "text": "5.\tالتأكيد على تحسين الاتصال وتسهيل التفاعل الاجتماعي داخل وخارج العمل. من خلال تشجيع الأنشطة الاجتماعية مثل عقد غداء عمل للفريق، أو عقد اجتماعات غير الرسمية، أو تطبيق أي فكرة تجعل الموظفين يبتعدون عن مكاتبهم والتحدث مع بعضهم البعض بشكل عفوي وودي."
      }
    ]
  },
  {
    "key": "txtCommunicationExtremelyUnhappyDriverRecommendation",
    "text": "This indicates that employees are extremely dissatisfied due to the absence of communication between teams and departments, vertically and horizontally, and signals immediate care to motivate and satisfy them.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن الموظفين غير سعداء إطلاقاً بسبب الافتقار إلى التواصل بين الفرق والأقسام. ويحتاج مستوى التواصل في مكان العمل إلى اهتمام فوري لتحفيز الموظفين وإسعادهم."
      }
    ]
  },
  {
    "key": "txtCommunicationUnhappyDriverRecommendation",
    "text": "This indicates that the employees are dissatisfied with the communication level between teams and other departments. This, in return, affects cooperation between departments; this represents their need for more Two-way communication.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن الموظفين غير سعداء بمستوى التواصل بين الفرق والأقسام، ويؤثر هذا على التعاون داخل القسم وبين الأقسام الأخرى. ويشعرون أنهم بحاجة إلى مزيد من التواصل المتبادل (two-way communication) في مكان العمل."
      }
    ]
  },
  {
    "key": "txtCommunicationHappyDriverRecommendation",
    "text": "This indicates that the employees are happy with the effective communication and cooperation at a team and departmental level. This shows that when communication levels are high, employees are motivated in response to the general environment at the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن الموظفين سعداء بالتواصل والتعاون الجيد بين الفرق والأقسام. ويدل ذلك على أنه عندما يكون التواصل مرتفعاً، ويشعر الموظفين بالتشجيع بسبب الجو العام في مكان العمل."
      }
    ]
  },
  {
    "key": "txtCommunicationExtremelyHappyDriverRecommendation",
    "text": "This indicates that the employees are extremely happy with the effective communication and cooperation at a team and departmental levels and being happier. In contrast, Two-Way communication is done with ease at the workplace without being hesitant and/or considering consequences from sharing their thoughts freely.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتائج إلى أن الموظفين سعداء للغاية بالتواصل والتعاون الفعال في العمل بين الفرق والأقسام، بالإضافة إلى أنهم يكونون أكثر ميولاً للشعور بالسعادة عندما يشعرون أن التواصل المتبادل (two-way communication) سلساً في مكان العمل ويسمح لهم بالتعبير عن آرائهم دون الخوف من التبعات."
      }
    ]
  },
  {
    "key": "txtConditionsDriverDesc",
    "text": "Employees’ comfort and happiness are crucial to their performance, productivity, and results’ quality. The working environment conditions directly impact employees; thus, implementing suitable and flexible procedures improves employees’ retainment. It drives them towards completing tasks enthusiastically and dedicatedly as it is in human nature to put in the effort in something that rewards happiness.\n  Conclusively: An environment that cares about the psychological and health conditions brings out its employees' fully utilized efforts and talents by creating a positive environment, which reflects the workplace's reputation, thus a place where high skills aspire to work.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تؤثر ظروف بيئة العمل بشكل مباشر على إحساس الموظفين بالراحة والسعادة الوظيفية، كما تمتلك أهمية كبيرة في تحسين أداء العاملين وإنتاجيتهم وجودة مخرجاتهم، فوجود بيئة عمل داخلية مناسبة تتوفر بها كافة الوسائل التي تساعد على إنجاز الأعمال بسهولة ويسر، وتوفر سياسات وإجراءات مرنة وملائمة لطبيعة الأعمال تساهم في الاحتفاظ بالموظفين ودفعهم للالتزام بعملهم وإنجاز مهامهم المطلوبة بحماس وتفاني حيث يمنح الإنسان بطبيعته جهده وطاقته لشيء يمنحه السعادة.\n\n  وبالخلاصة: إن بيئة العمل التي تُراعى فيها النواحي النفسية والصحية تؤدي إلى إخراج أفضل المهارات والمواهب لدى الموظفين، وتخلق جو ملئ بالإيجابية بينهم والذي ينعكس على سمعة مكان العمل ليصبح مكاناً جاذباً يتطلّع الجميع للعمل فيه ويشعر موظفيه بالسعادة الوظيفية.\n  "
      }
    ]
  },
  {
    "key": "txtConditionsActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve workplace Conditions that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين ظروف بيئة العمل:"
      }
    ]
  },
  {
    "key": "txtConditionsActionDescription_1",
    "text": "Provide a working environment that considers space, lighting, design, furniture, appliances, cleanliness, catering, and meetings’ rooms up to modern standards, in terms of spaciousness, modern technologies, uplifting designs, and comfortable with accessible facilities. Also, an interior layout that allows visual communication between peers.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير بيئة عمل جيدة من حيث تنظيم المساحة والإضاءة والتصميم وجودة الأثاث وحداثة الأجهزة المستخدمة ونظافة ونظافة المكان وتخصيص أماكن ملائمة لتناول الأطعمة والاجتماعات، والتأكد من تصميم المكان بطريقة تسمح بانسيابية التواصل المرئي بين الموظفين وسهولة الوصول للمرافق."
      }
    ]
  },
  {
    "key": "txtConditionsActionDescription_2",
    "text": "Divisional physical separation is essential among any workplace per each’s work practices. Departments that rely extensively on conducting phone calls and are relatively mobile should be separated from other departments with employees that are stationary with less reliance on phone calls.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكيد على الفصل بين الأقسام التي تتطلب طبيعة عملها استخدام المكالمات الهاتفية والتنقل باستمرار والأقسام الأخرى التي يكون موظفيها ثابتين ولا يعتمدون على المكالمات الهاتفية للحصول على أجواء مهنية أكثر راحة وتركيزاً."
      }
    ]
  },
  {
    "key": "txtConditionsActionDescription_3",
    "text": "Update the policies and procedures to reflect the employees’ values and unique culture, considering the dynamic circumstances and the employees’ different roles.",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث السياسات والإجراءات الخاصة بالعمل باستمرار بحيث تعكس القيم والثقافة الخاصة بالموظفين واحتياجاتهم في مكان العمل مع مراعاة الظروف المتغيرة ومرونة التطبيق بما يتناسب مع كافة الموظفين وأدوارهم ومسؤولياتهم الوظيفية. "
      }
    ]
  },
  {
    "key": "txtConditionsActionDescription_4",
    "text": "Accommodating a work-life balance results in a success-driven team. It ensures the employees’ healthy state of mind, wellbeing, and improved productivity by offering hybrid work, sick and emergency leaves, and flexible working hours tailored to each’s specific needs when and if applicable",
    "translations": [
      {
        "language": "AR",
        "text": "المحافظة على خلق التوازن بين كل من العمل والحياة الشخصية من خلال ترتيبات العمل المتسمة بالمرونة لضمان راحة ونجاح الموظف ولتقليل ضغوطه النفسية ومن الأمثلة على ذلك السماح للموظفين بالعمل من المنزل، أو أخذ إجازة للمواعيد الطبية أو الحالات الطارئة والعمل لساعات مرنة تناسب احتياجاتهم الشخصية."
      }
    ]
  },
  {
    "key": "txtConditionsExtremelyUnhappyDriverRecommendation",
    "text": "This result indicates that the employees are extremely unhappy, discomforted, and dissatisfied with their work environment and implemented procedures, thus hindering their focus from accomplishing required tasks, resulting in less motivated and productive teams that could demean it publicly, hence, Reflecting a negative image.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء ولا يشعرون بالراحة على الإطلاق حيال ظروف بيئة العمل، وغير راضيين أبداً عن السياسات والإجراءات المتبعة في أماكن عملهم مما يشعرهم بالاستياء وعدم التركيز لإتمام مهامهم المطلوبة ناتجة بطاقم ذو كفاءة ودافعية اقل، ومن الممكن انتقاد ظروف بيئة عملهم في العلن خارج نطاق العمل مما تعكس انطباعاً سلبياً."
      }
    ]
  },
  {
    "key": "txtConditionsUnhappyDriverRecommendation",
    "text": "This result indicates the discomfort and unhappiness of employees with regards to their work environment, and implemented procedures, thus hindering their focus from accomplishing required tasks",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء ولا يشعرون بالراحة حيال ظروف بيئة العمل، وغير راضيين عن السياسات والإجراءات المتبعة مما يشعرهم بالاستياء وعدم التركيز لإتمام مهامهم المطلوبة."
      }
    ]
  },
  {
    "key": "txtConditionsHappyDriverRecommendation",
    "text": "his result indicates that employees are happy and satisfied with their work environment and how smooth the implemented procedures are, resulting in productive teams, submitting deliverables on time with the expected quality, and complementing their work environment with gratitude.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء ومرتاحون لظروف بيئة العمل، ويشعرون بالرضا عن مدى سلاسة السياسات والإجراءات المتبعة في أماكن عملهم مما يشعرهم بالحماس والتحفيز تجاه انجاز مهامهم بالوقت المناسب وبالجودة المطلوبة، ويثنون على ظروف بيئة عملهم."
      }
    ]
  },
  {
    "key": "txtConditionsExtremelyHappyDriverRecommendation",
    "text": "This result indicates that employees are extremely happy and satisfied with all aspects of the work environment and how smooth the implemented procedures are, resulting in driven, motivated teams submitting deliverables on time with the expected quality and complementing their work environment publicly with gratitude.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء ومرتاحون جداً لظروف بيئة العمل من كافة النواحي، ويشعرون بالرضا عن مدى سلاسة السياسات والإجراءات المتبعة مما يشعرهم بالحماس والتحفيز تجاه انجاز مهامهم بالوقت المناسب وبالجودة المطلوبة، ويثنون على ظروف بيئة عملهم في العلن، داخل وخارج نطاق العمل. "
      }
    ]
  },
  {
    "key": "txtCareerAdvancementDriverDesc",
    "text": "One of the key pillars for personal and career happiness is career advancement. Employees seek to accomplish a variety of successes to advance and take pride in their work while attaining self-actualization. Having a planned, clear, and just career path empowers their passion to progress. It achieves higher positions up the hierarchy, igniting a motive to infuse and interact while leveraging opportunities to utilize their existing skillset and expand it.\n\n  Career Advancement aids in shortening the gap between the employees’ actual and required capabilities while identifying competent individuals to fill in different managerial, leadership-related, and vocational-skill vacancies accordingly while attaining exceptional talent and improve employees’ retention ratio.\n\n  Conclusively: Employees actively seek career advancement to keep pace with the era’s economic and social changes and challenges, emphasizing that taking on appropriate career paths is vital for their career happiness.\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "يعد التطور الوظيفي أحد متطلبات السعادة الوظيفية والشخصية، حيث يسعى الموظفون لتحقيق العديد من الانجازات التي تشعرهم بالتقدم والفخر وتحقيق ذاتهم، لذلك فإن رؤيتهم لمسار وظيفي واضح وعادل تعزز من شغفهم في التطور والوصول لأعلى مراتب السلم الوظيفي كما تولد لديهم حافز قوي للاندماج والتفاعل، واستغلال كافة الفرص التي تمكنهم من استخدام مهاراتهم واكتساب خبرات جديدة.\n\n  ومن جهة أخرى، يساعد التطور الوظيفي على سد الفجوة بين قدرات الموظفين ومتطلبات الوظيفة والتعرف على الأفراد المؤهلين لتولي المناصب المختلفة، منها القيادية والمهنية والإدارية واجتذاب المواهب الاستثنائية، ورفع معدل الاحتفاظ بالموظفين.\n\n  وبالخلاصة: يسعى الموظفون كافة للتطور الوظيفي بقدر الإمكان لمواكبة تغيرات وصعوبات العصر من احتياجات مادية ومجتمعية وغيرها، تأكيدا على أن تخطيط الفرد ل ليكون في مسار وظيفي مناسب ومهماً جداً لتحقيق غاياته والوصول إلى السعادة الوظيفية.\n  "
      }
    ]
  },
  {
    "key": "txtCareerAdvancementActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve Career Advancement that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين التطور الوظيفي:"
      }
    ]
  },
  {
    "key": "txtCareerAdvancementActionDescription_1",
    "text": "Ensure having a clear and fair career path for all employees at all job levels.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من وجود خطة مسار وظيفي واضحة وعادلة للموظفين على كافة المستويات."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementActionDescription_2",
    "text": "Construct development and continuous learning culture by preparing annual training and guidance plans while abiding with each employee’s work nature and training needs, measured by the annual appraisal.",
    "translations": [
      {
        "language": "AR",
        "text": "خلق ثقافة التطور والتعلم المستمر، من خلال اعداد خطط التدريب السنوية والبرامج التوجيهية بما يتوافق مع طبيعة عمل كل موظف واحتياجاته التدريبية المستمدة من عملية التقييم السنوي."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementActionDescription_3",
    "text": "Correlate career development with professional, academic certificates, and courses related to employees’ work nature, with the compensation, rewards, and appraisal programs.",
    "translations": [
      {
        "language": "AR",
        "text": "ربط التطور الوظيفي بالإنجازات العملية والعلمية مثل الشهادات المهنية الاحترافية والأكاديمية والدورات ذات العلاقة بطبيعة العمل ببرامج المكافآت والتقييمات والترقيات."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementActionDescription_4",
    "text": "Ensure employees are granted exceptional permissions to obtain academic and professional degrees, attend training courses and workshops, such as flexible working hours that suit attendance dates, exam preparation dates, and more.",
    "translations": [
      {
        "language": "AR",
        "text": "الحرص على منح الموظفين تسهيلات استثنائية للحصول على الشهادات الأكاديمية والمهنية وحضور الدورات التدريبية وورش العمل، مثل ساعات دوام مرنة تتناسب مع مواعيد محاضراتهم وإجازات دراسية لتقديم الاختبارات وغيرها."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementExtremelyUnhappyDriverRecommendation",
    "text": "This result indicates that the employees are extremely unhappy with their current positions and the implemented career development plan. Alongside their extreme dissatisfaction with the incentives, facilities, and support they are offered towards their career development. They urgently desire to change their workplace as it is inversely aligned with their career ambitions.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء على الإطلاق بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ولا يشعرون بالرضا أبداً عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم يرغبون في تغيير مكان عملهم فوراً لأنه لا يتناسب مع طموحاتهم الوظيفية."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementUnhappyDriverRecommendation",
    "text": "This result indicates that the employees are unhappy with their current positions and their implemented career development plan. Alongside their dissatisfaction with the incentives, facilities, and the support they are offered towards their career development. They consider changing their workplace as it isn’t aligned with their career ambitions.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ولا يشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم يرغبون في تغيير مكان عملهم لأنه لا يتناسب مع طموحاتهم الوظيفية."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementHappyDriverRecommendation",
    "text": "This result indicates that the employees are happy with their current positions and the implemented career development plan. Alongside their satisfaction with the incentives, facilities, and support they are offered towards their career development. They provide utmost efforts to optimize productivity, actualize themselves, and achieve their ambitions.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء بمناصبهم الحالية وبخطة المسار والتطور الوظيفي المعمول بها، ويشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم في سبيل تطورهم الوظيفي، مما يجعلهم لا يرغبون في تغيير مكان عملهم، بل ويبذلون جهودهم في تحقيق ذاتهم وطموحاتهم ورفع إنتاجية العمل."
      }
    ]
  },
  {
    "key": "txtCareerAdvancementExtremelyHappyDriverRecommendation",
    "text": "This result indicates that employees are extremely happy with their current positions and the implemented career development plan. Alongside their extreme satisfaction with the incentives, facilities, and the support they are offered towards their career development, thus their absolute unwillingness to change their workplaces, but on the contrary, provide their utmost efforts to optimize productivity, actualize themselves, and achieve their ambitions.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء للغاية بمناصبهم الحالية وبخطة التطور الوظيفي المعمول بها، ويشعرون بالرضا عن الدعم والحوافز والتسهيلات المقدمة لهم، مما يجعلهم لا يرغبون أبداً في تغيير مكان عملهم، بل ويبذلون أقصى جهودهم لتحقيق ذاتهم وطموحاتهم ورفع إنتاجيتهم."
      }
    ]
  },
  {
    "key": "txtContinuityDriverDesc",
    "text": "The continuity and sustainability of the workplace’s success is a core pillar that grants the employees stability and security. Employees need to operate in a stable, well-equipped workplace that can adapt to changing situations and effectively correspond to work plans consistent with best practices derived from the workplace’s strategy while aligning teams to achieve it cooperatively. This empowers the workforce with higher trust in their leaders and their decisions to preserve workflows that, in turn, promote creativity and productivity.\n\n  Conclusively: Continuity is an imperative pillar that should exist at all stages of a workplace, as it indicates stability, security and provide career happiness to employees, which lessens their career and job concerns and fears that could hinder their sense of initiative and creativity\n  ",
    "translations": [
      {
        "language": "AR",
        "text": "تُعد استمرارية واستدامة نجاح مكان العمل من الركائز التي تمنح الموظفين الأمان والاستقرار. حيث يحتاجون للعمل في مكان مستقر ومجهز للتأقلم مع الظروف المتغيرة للتعامل معها بشكل فعال بناءً على خطط عمل منسقة لأفضل الممارسات ومنبثقة من استراتيجية مكان العمل ليعمل الجميع نحو تحقيقها بتكاتف واجتهاد مما يمنح الموظفين الثقة بقادتهم وقراراتهم وأساليبهم في المحافظة على الأعمال واستدامتها والذي بدوره يحفز الموظفين على الابداع والإنتاجية.  وبالخلاصة: الاستمرارية هي ضرورة حتميّة وركيزةً أساسيّة لا بدّ من وجودِها لضمان شعور الموظف بالاستقرار والامان والسعادة الوظيفية التي تقلل من قلقه وخوفه حيال مستقبله الوظيفي وخسارته لعمله وقتل روح المبادرة والابداع."
      }
    ]
  },
  {
    "key": "txtContinuityActionDesc",
    "text": "Listed below are some procedures that can be implemented to improve Continuity that include, but are not limited to:",
    "translations": [
      {
        "language": "AR",
        "text": "فيما يلي بعض الإجراءات التي من الممكن الاستعانة بها عند الحاجة على سبيل المثال لا الحصر والتي من شأنها تحسين الاستمرارية:"
      }
    ]
  },
  {
    "key": "txtContinuityActionDescription_1",
    "text": "Ensure the clear delivery and correct interpretation of the mission and vision statements and strategic goals are communicated to the employees, emphasizing each employee's roles on an individual and teams level.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من إيصال الرسالة والرؤية والأهداف الاستراتيجية وتوضيحها لكافة الموظفين وبيان مسؤولية ودور كل موظف على الصعيدين الفردي وكمجموعة للالتزام بها وتحقيقها."
      }
    ]
  },
  {
    "key": "txtContinuityActionDescription_2",
    "text": "Adopt a holistic continuity methodology to practice by implementing all necessary steps required to ensure the employees’ sense of security and stability by cherishing their efforts, ensure the retention of qualified employees by adopting the measures needed ",
    "translations": [
      {
        "language": "AR",
        "text": "اتباع وممارسة نهج فكري شامل عن طريق اتخاذ جميع الخطوات اللازمة لضمان شعور الموظف بالأمان والاستقرار الوظيفي من خلال تثمين جهودهم والحرص على عدم فقدان الأكفاء منهم."
      }
    ]
  },
  {
    "key": "txtContinuityActionDescription_3",
    "text": "Ensure that manuals and guidelines are available to staff for use in exceptional cases to enhance employees’ knowledge of the workplace’s readiness and capabilities.",
    "translations": [
      {
        "language": "AR",
        "text": "التأكد من وجود الأدلة الارشادية والتوجيهية في متناول يد الموظفين لاستخدامها في الحالات الاستثنائية لتعزيز معرفة الموظفين بجاهزية مكان العمل."
      }
    ]
  },
  {
    "key": "txtContinuityActionDescription_4",
    "text": "Continuously motivate employees by providing them with the needed space to excel, innovate, produce initiatives that drive and develop the work creatively within a structure that ensures sustainability.",
    "translations": [
      {
        "language": "AR",
        "text": "تحفيز الموظفين باستمرار نحو التمييز والابداع من خلال توفيريهم بالمساحة الكافية للخروج بمبادرات وأفكار ريادية التي من شأنها النهوض وتطوير مكان العمل بمنهجية استمرارية داعمة لاستدامته."
      }
    ]
  },
  {
    "key": "txtContinuityExtremelyUnhappyDriverRecommendation",
    "text": "This result indicates that the employees are extremely unhappy with the stability and job security they possess at their workplace, derived from its instability and their unknowing of the strategic goals the workplace is trying to achieve. Additionally, they are apprehensive about their career's future as well as their distrust with the leadership styles practiced by their managers when dealing with unprecedented circumstances.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء على الإطلاق في أماكن عملهم نتيجة لعدم استقرار وثبات أماكن عملهم وعدم معرفتهم للأهداف الاستراتيجية التي تسعى لتحقيقها ويشعرون بالقلق الشديد حيال مستقبلهم الوظيفي، كما أنهم لا يثقون أبداً بالأساليب القيادية لرؤسائهم ولا بقدرتهم على التعامل مع الظروف الاستثنائية."
      }
    ]
  },
  {
    "key": "txtContinuityUnhappyDriverRecommendation",
    "text": " This result indicates that the employees are unhappy with the stability and job security they possess at their workplace, derived from its instability and their unknowing of the strategic goals the workplace is trying to achieve. Additionally, they are worried about their career's future as well as their distrust of the leadership styles practiced by their managers when dealing with unprecedented circumstances ",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين غير سعداء في أماكن عملهم نتيجة لعدم استقرار وثبات أماكن عملهم وعدم معرفتهم للأهداف الاستراتيجية التي تسعى لتحقيقها ويشعرون بالقلق حيال مستقبلهم الوظيفي، كما أنهم لا يثقون بالأساليب القيادية لرؤسائهم ولا بقدرتهم على التعامل مع الظروف الاستثنائية."
      }
    ]
  },
  {
    "key": "txtContinuityHappyDriverRecommendation",
    "text": "This result indicates that the employees are happy with the stability and job security they possess, derived by the continuity and sustainability existent at their workplace, while not having any concerns about their career's future. ",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء بمدى الاستقرار والأمن الوظيفي الذي يتمتعون به نتيجة للاستمرارية والديمومة التي تحظى بها أماكن عملهم ولا يشعرون بالقلق حيال مستقبلهم الوظيفي."
      }
    ]
  },
  {
    "key": "txtContinuityExtremelyHappyDriverRecommendation",
    "text": "This result indicates that the employees are extremely happy with the stability and job security they possess, derived by the continuity and sustainability existent at their workplace, while not having any concerns about their career's future. Moreover, they praise the leadership styles of their managers when dealing with unprecedented circumstances.",
    "translations": [
      {
        "language": "AR",
        "text": "تشير هذه النتيجة إلى أن الموظفين سعداء للغاية بمدى الاستقرار والأمن الوظيفي الذي يتمتعون به نتيجة للاستمرارية والديمومة التي تحظى بها أماكن عملهم ولا يشعرون بالقلق أبداً حيال مستقبلهم الوظيفي، كما يشيدون بالأساليب القيادية لمدراءهم وحكمتهم في التعامل مع الظروف الاستثنائية."
      }
    ]
  },
  {
    "key": "0",
    "text": "0",
    "translations": [
      {
        "language": "AR",
        "text": "0"
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض f مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox, or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. \nNote: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية. \nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر. "
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nNote: A minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost employee happiness.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى السعادة الوظيفية."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "New Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "خطة عمل جديدة"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_S_T_4_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_4_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Factor Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب العامل"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Based on the selected happiness factors, choose the ones you want to focus on. Note: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى عوامل السعادة المحددة، اختر العوامل التي ترغب في التركيز عليها. تلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض"
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث.\nملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      }
    ]
  },
  {
    "key": "AP_S_T_26_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      }
    ]
  },
  {
    "key": "AP_S_T_26_DESCRIPTION",
    "text": "You can delete any initiative by clicking on the three vertical dots",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "txtAveraged",
    "text": "Averaged",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      }
    ]
  }
]